import { devicesFrCa } from '@mangovoice/devices-ui'
import { extensionsFrCa } from '@mangovoice/extensions-ui'
import { hotelsFrCa } from '@mangovoice/hotels-ui'
import { messagingFrCa } from '@mangovoice/messaging-ui'
import { musicOnHoldFrCa } from '@mangovoice/music-on-hold-ui'
import { pbxLocationsFrCa } from '@mangovoice/pbx-locations-ui'
import { pbxSettingsFrCa } from '@mangovoice/pbx-settings-ui'
import { phoneNumbersFrCa } from '@mangovoice/phone-numbers-ui'
import { soundClipsFrCa } from '@mangovoice/soundclips-ui'
import { systemSettingsFrCa } from '@mangovoice/system-settings-ui'
import { userGroupsFrCa } from '@mangovoice/user-groups-ui'
import { webhooksFrCa } from '@mangovoice/webhooks-ui'

import { en } from './en'
import { scheduleFrCa } from './schedule.fr_ca'

export const fr_ca = {
  translation: {
    'Welcome to React': `Bienvenue à React et react-i18next`,
    yesterday: `Hier`,
    today: "Aujourd'hui",
    hour: `Heure`,
    day: `Jour`,
    week: `Semaine`,

    baseSettings: {
      profile: `Profil`,
      snippets: `Extraits`,
      phone: `Téléphone`,
      fax: `Télécopieur`,
      notifications: `Notifications`,
      audio: `Audio`,
      updates: `Mises à jour`,
      blockedNumbers: `Numéros bloqués`,
      integrations: `Intégrations`,
      callCenter: "Centre d'appels",
      experiments: `Expériences`,
      shortcutKeys: `Raccourcis clavier`,
      collapse: `Réduire`,
      expand: `Développer`,
      new: `Nouveau`,
      admin: `Administration`,
      closeAdmin: `Fermer l'administration`,
      adminSections: `Sections d'administration`,
    },

    nav: {
      voicemail: `Messagerie vocale`,
      calls: `Appels`,
      missedCalls: `Appels manqués`,
      text: `Texte`,
      messaging: `Messagerie`,
      fax: `Télécopieur`,
      contacts: `Contacts`,
      settings: `Paramètres`,
      webPhone: `Téléphone web`,
      reporting: `Rapports`,
      hotels: `Hôtels`,
      switchboard: `Tableau de bord des appels`,
      devices: `Appareils`,
      extensions: `Extensions`,
      messagingGroups: `Groupes de messagerie`,
      soundClips: `Clips Audio`,
      musicOnHold: `Musique d'attente`,
      phoneNumbers: `Numéros de Téléphone`,
      locations: `Emplacements`,
      pbxSettings: `Paramètres PBX`,
      schedules: `Horaires`,
      integrations: `Intégrations`,
      systemSettings: `Paramètres système`,
      users: `Utilisateurs`,
      userGroups: `Groupes d'utilisateurs`,
      apiAccess: `Accès API`,
      developers: `Développeurs`,
      mainNavigation: `Navigation principale`,
      skipToMainContent: `Passer au contenu principal`,
      callAnalytics: `Analyse des appels`,
      status: `Statut`,
    },

    users: {
      detail: {
        close: `Fermer les détails de l'utilisateur`,
        loadingUser: `Chargement de l'utilisateur...`,
        pbxAssociations: {
          heading: `Associations PBX`,
          addToPbx: `Ajouter au PBX`,
          filterPlaceholder: `Filtrer les associations PBX...`,
          filterAriaLabel: `Filtrer les associations PBX`,
          empty: `Cet utilisateur n'est associé à aucun PBX.`,
          noMatches: `Aucune association PBX ne correspond à votre recherche.`,
        },
      },
      generalInfo: {
        heading: `Informations sur l'utilisateur`,
        copyCognitoKey: `Copier "Cognito Key"`,
        resetPassword: `Réinitialiser le mot de passe`,
        resetPasswordAria: `Réinitialiser le mot de passe`,
        editUserInformation: `Modifier les informations de l'utilisateur`,
        deactivateUser: `Désactiver l'utilisateur`,
        activateUser: `Activer l'utilisateur`,
        username: `Nom d'utilisateur`,
        name: `Nom`,
        role: `Rôle`,
        email: `Courriel`,
        lastLoggedIn: `Dernière connexion`,
        created: `Créé`,
        updated: `Mis à jour`,
      },
      pbxAssociationCard: {
        editAria: `Modifier l'association pour {{pbxName}}`,
        removeAria: `Retirer {{userName}} de {{pbxName}}`,
        assignedExtensions: `Postes assignés`,
        faxEmail: `Courriel de télécopie`,
        faxNumber: `Numéro de télécopie`,
        pin: `NIP`,
        faxTitle: `Titre de télécopie`,
      },
      phonePermissions: {
        heading: `Autorisations téléphoniques`,
        loading: `Chargement des autorisations téléphoniques...`,
        empty: `Cet utilisateur n'appartient à aucun groupe d'autorisations téléphoniques.`,
        editAria: `Modifier les autorisations téléphoniques pour {{pbxName}}`,
        noGroupsAssigned: `Aucun groupe assigné.`,
      },
      pbxUserForm: {
        titleAdd: `Ajouter au PBX`,
        titleEdit: `Modifier l'association PBX`,
        pbxLabel: `PBX`,
        pbxSearchPlaceholder: `Rechercher un PBX par nom...`,
        pbxSearchAria: `Rechercher les options de PBX par nom`,
        pbxSearching: `Recherche...`,
        pbxTypeToSearch: `Saisissez pour rechercher un PBX...`,
        pbxNoMatches: `Aucun PBX ne correspond à cette recherche.`,
        faxTitleLabel: `Titre de télécopie`,
        faxTitlePlaceholder: `Titre de télécopie`,
        sendingFaxEmailLabel: `Courriel de télécopie (envoi)`,
        sendingFaxEmailPlaceholder: `Adresse courriel de télécopie`,
        invalidEmail: `Saisissez une adresse courriel valide.`,
        sendingFaxNumberLabel: `Numéro de télécopie (envoi)`,
        faxNumberSearchPlaceholder: `Rechercher des numéros de télécopie...`,
        faxNumberSelectPbxFirst: `Sélectionnez d'abord un PBX`,
        faxNumberSearchAria: `Rechercher les options de numéro d'envoi de télécopie`,
        faxNumbersLoading: `Chargement des numéros de télécopie...`,
        faxNumbersEmpty: `Aucun numéro de télécopie trouvé pour ce PBX.`,
        pinLabel: `NIP`,
        pinPlaceholder: `NIP à 4 chiffres (1000-9999)`,
        userGroupsLabel: `Groupes d'utilisateurs`,
        userGroupsSelected_one: `{{count}} sélectionné`,
        userGroupsSelected_other: `{{count}} sélectionnés`,
        cancel: `Annuler`,
        submitAdd: `Ajouter au PBX`,
        submitEdit: `Enregistrer les modifications`,
      },
      editPhonePermissions: {
        title: `Modifier les autorisations téléphoniques : {{userName}}`,
        pbxLabel: `PBX : {{pbxName}}`,
        groups: `Groupes`,
        noGroups: `Aucun groupe disponible pour ce PBX.`,
        required: `(obligatoire)`,
        selectedCount: `{{selected}} sur {{total}} sélectionnés`,
        close: `Fermer`,
        submit: `Mettre à jour les autorisations téléphoniques`,
      },
      formatAssignedAssets: {
        extension_one: `{{count}} poste assigné`,
        extension_other: `{{count}} postes assignés`,
        device_one: `{{count}} appareil assigné`,
        device_other: `{{count}} appareils assignés`,
        and: ` et `,
      },
      toast: {
        userCreated: {
          title: `Utilisateur créé`,
          description: `{{firstName}} {{lastName}} a été créé.`,
        },
        userCreateError: {
          title: `Erreur lors de la création de l'utilisateur`,
        },
        userUpdated: {
          title: `Utilisateur mis à jour`,
        },
        userUpdateError: {
          title: `Erreur lors de la mise à jour de l'utilisateur`,
        },
        pbxAdded: {
          title: `Utilisateur ajouté au PBX`,
        },
        pbxUpdated: {
          title: `Association PBX mise à jour`,
        },
        error: `Erreur`,
        associationRemoved: {
          title: `Association retirée`,
          description: `{{name}} a été retiré de ce PBX.`,
        },
        alreadyRemoved: {
          title: `Déjà retiré`,
          description: `Cet utilisateur n'a pas été trouvé dans le PBX et a peut-être déjà été retiré.`,
        },
        removeFailed: `Échec du retrait de l'utilisateur du PBX.`,
        noPhonePermissionChanges: {
          title: `Aucun changement d'autorisation téléphonique`,
        },
        phonePermissionsUpdated: {
          title: `Autorisations téléphoniques mises à jour`,
        },
        updateGroupFailed: `Échec de la mise à jour de « {{name}} ».`,
        phonePermissionsUpdateError: {
          title: `Échec de la mise à jour des autorisations téléphoniques`,
          fallback: `Impossible de mettre à jour les autorisations téléphoniques.`,
        },
        defaultUserName: `Utilisateur`,
      },
      removeDialog: {
        cannotTitle: `Impossible de retirer l'utilisateur du PBX`,
        thisUserCapitalized: `Cet utilisateur`,
        cannotBody: `<bold>{{userName}}</bold> a {{assets}} sur ce PBX. Réassignez ou supprimez ces ressources avant de retirer cet utilisateur du PBX.`,
        ok: `OK`,
        confirmTitle: `Retirer l'utilisateur du PBX ?`,
        thisUser: `cet utilisateur`,
        confirmBody: `Cela retirera <bold>{{userName}}</bold> du PBX sélectionné.`,
        cancel: `Annuler`,
        remove: `Retirer`,
      },
      list: {
        title: `Utilisateurs`,
        searchPlaceholder: `Rechercher par nom, nom d'utilisateur ou courriel...`,
        searchAriaLabel: `Rechercher des utilisateurs`,
        newUser: `Nouvel utilisateur`,
        newUserAriaLabel: `Créer un nouvel utilisateur`,
        newUserDisabledAriaLabel: `Créer un nouvel utilisateur (désactivé)`,
        newUserPermissionTooltip: `Vous n'avez pas la permission de créer des utilisateurs`,
        clickToCopy: `Cliquez pour copier`,
        copied: `Copié !`,
        loading: `Chargement des utilisateurs...`,
        error: `Erreur`,
        emptyNoResultsTitle: `Aucun résultat trouvé`,
        emptyNoResultsDescription: `Essayez de modifier vos termes de recherche`,
        emptyNoUsersTitle: `Aucun utilisateur pour l'instant`,
        emptyNoUsersDescription: `Commencez par créer votre premier utilisateur`,
        removeFromPbxTitle: `Retirer {{name}} du PBX`,
        removeFromPbxDescription: `Si cet utilisateur a des appareils ou des postes attribués, ils seront réattribués à l'utilisateur sélectionné.`,
        reassignAndRemove: `Réattribuer et retirer`,
        cancel: `Annuler`,
        reassignAssetsTo: `Réattribuer les ressources à`,
        selectUserPlaceholder: `Sélectionnez un utilisateur...`,
        searchingUsers: `Recherche...`,
        noMatchingUsers: `Aucun utilisateur correspondant`,
        searchUsersToReassign: `Rechercher des utilisateurs pour la réattribution`,
        candidateLoadFailed: `Impossible de charger les utilisateurs. Vérifiez votre connexion et réessayez.`,
        noOtherUsersOnPbx: `Il n'y a pas d'autres utilisateurs sur ce PBX. Ajoutez un autre utilisateur avant de retirer celui-ci afin que ses ressources puissent être réattribuées.`,
        defaultUserName: `Utilisateur`,
        column: {
          name: `Nom`,
          usernameOrEmail: `Nom d'utilisateur / Courriel`,
          role: `Rôle`,
          faxEmail: `Courriel de télécopie`,
          lastLogin: `Dernière connexion`,
          lastUpdated: `Dernière mise à jour`,
          action: `Action`,
        },
        pagination: {
          resultsPerPage: `Résultats par page :`,
          previousPage: `Page précédente`,
          nextPage: `Page suivante`,
          jumpToPage: `Aller à la page {{page}}`,
          all: `Tous`,
          recordRange: `{{start}}—{{end}} sur {{total}}`,
          recordRangeEmpty: `0 sur 0`,
        },
      },
      resetPassword: {
        toast: {
          copiedTitle: `Le lien de réinitialisation a été copié dans le presse-papiers`,
          copyFailedTitle: `Le lien de réinitialisation a été généré, mais n'a pas pu être copié`,
          manualCopyDescription: `Copiez cette URL de réinitialisation manuellement : {{url}}`,
          missingUrlTitle: `Échec de la génération du lien de réinitialisation`,
          missingUrlDescription: `Aucune URL de réinitialisation n'a été renvoyée.`,
          requestFailedTitle: `Échec de la réinitialisation du mot de passe`,
          unexpectedErrorDescription: `Une erreur inattendue s'est produite.`,
        },
      },
      create: {
        loadingForm: `Chargement du formulaire d'utilisateur...`,
      },
      edit: {
        loadingDetails: `Chargement des détails de l'utilisateur...`,
        retryLoadingRoles: `Réessayer le chargement des rôles`,
      },
      form: {
        heading: {
          newUser: `Nouvel utilisateur`,
          editUser: `Modifier l'utilisateur`,
        },
        section: {
          pbxAssignment: `Attribution du PBX`,
        },
        field: {
          firstName: `Prénom`,
          lastName: `Nom`,
          username: `Nom d'utilisateur`,
          usernameHelper: `Obligatoire. 4 à 150 caractères. Lettres, chiffres, points ou tirets uniquement. Remarque : le nom d'utilisateur ne peut pas être modifié après la création.`,
          email: `Courriel`,
          emailHelper: `Facultatif. Le courriel ne peut pas être modifié une fois défini.`,
          isStaff: `Personnel Mango?`,
          staffHelperIntro: `Cette désignation accorde un accès complet au système, à quelques exceptions près :`,
          staffHelperBullet1: `L'utilisateur ne peut pas attribuer la désignation de superutilisateur Mango à d'autres utilisateurs.`,
          staffHelperBullet2: `L'utilisateur ne peut pas modifier les superutilisateurs Mango.`,
          staffHelperBullet3: `L'utilisateur ne peut pas modifier les serveurs, fournisseurs ou fabricants d'appareils.`,
          isSuperuser: `Superutilisateur Mango`,
          role: `Rôle`,
          rolePlaceholder: `------`,
          roleUnavailable: `Options de rôle indisponibles`,
          roleUnavailableHelper: `Les options de rôle ne sont pas disponibles.`,
          roleWarning: `AVERTISSEMENT : ce rôle s'applique à tous les PBX auxquels l'utilisateur appartient. Évaluez soigneusement les conséquences avant de faire des changements.`,
          pbx: `PBX`,
          pbxSearchPlaceholder: `Rechercher un PBX par nom...`,
          pbxSearchAriaLabel: `Rechercher des options de PBX par nom`,
          pin: `NIP`,
          pinPlaceholder: `NIP à 4 chiffres (1000-9999)`,
          faxTitle: `Titre du télécopieur`,
          faxTitlePlaceholder: `Titre du télécopieur`,
          sendingFaxEmail: `Courriel d'envoi de télécopie`,
          sendingFaxEmailPlaceholder: `Adresse courriel de télécopie`,
          sendingFaxNumber: `Numéro d'envoi de télécopie`,
          searchFaxNumbers: `Rechercher des numéros de télécopieur...`,
          selectPbxFirst: `Sélectionnez d'abord un PBX`,
          searchFaxNumbersAriaLabel: `Rechercher des options de numéro d'envoi de télécopie`,
          userGroups: `Groupes d'utilisateurs`,
        },
        combobox: {
          searching: `Recherche en cours...`,
          typeToSearchPbx: `Saisissez pour rechercher un PBX...`,
          noPbxMatches: `Aucun PBX ne correspond à cette recherche.`,
          loadingFaxNumbers: `Chargement des numéros de télécopieur...`,
          noFaxNumbers: `Aucun numéro de télécopieur trouvé pour ce PBX.`,
        },
        userGroups: {
          placeholder: `Sélectionnez des groupes d'utilisateurs...`,
          searchPlaceholder: `Filtrer les groupes d'utilisateurs...`,
          emptyLabel: `Aucun groupe d'utilisateurs disponible pour ce PBX.`,
          noResultsLabel: `Aucun groupe d'utilisateurs ne correspond à votre filtre.`,
          summary_one: `{{count}} groupe sélectionné`,
          summary_other: `{{count}} groupes sélectionnés`,
        },
        button: {
          cancel: `Annuler`,
          saveAndCreateAnother: `Enregistrer et en créer un autre`,
          createUser: `Créer l'utilisateur`,
          saveChanges: `Enregistrer les modifications`,
        },
      },
    },

    switchboard: {
      list: {
        title: `Tableau de bord des appels`,
        subtitle: `Créez et gérez les flux d'appels pour votre système vocal`,
        newSwitchboard: `Nouveau tableau de bord`,
        search: { placeholder: `Rechercher par nom...` },
        pagination: {
          resultsPerPage: `Résultats par page :`,
          previousPage: `Page précédente`,
          nextPage: `Page suivante`,
          jumpToPage: `Aller à la page {{page}}`,
          all: `Tous`,
        },
        grid: {
          errorTitle: `Erreur`,
          errorLoading: `Erreur lors du chargement des tableaux de bord :`,
          checkConsole: `Consultez la console pour plus de détails`,
          loading: `Chargement des tableaux de bord...`,
        },
        empty: {
          noDataTitle: `Aucun tableau de bord pour le moment`,
          noDataDescription: `Commencez par créer votre premier tableau de bord`,
          noResultsTitle: `Aucun tableau de bord sur cette page`,
          noResultsDescription: `Essayez d'ajuster la taille de la page ou d'aller à une autre page`,
          noSearchResultsTitle: `Aucun résultat trouvé`,
          noSearchResultsDescription: `Essayez d'ajuster les termes de recherche`,
        },
        card: {
          editAria: `Modifier le tableau de bord`,
          deleteAria: `Supprimer`,
          lastUpdated: `Dernière mise à jour`,
        },
        delete: {
          title: `Supprimer le tableau de bord`,
          body: `Êtes-vous sûr de vouloir supprimer « {{displayName}} » ? Cette action est irréversible.`,
          cancel: `Annuler`,
          confirm: `Supprimer`,
        },
        deleteSuccessToast: `Tableau de bord supprimé`,
        deleteFailedToast: `Échec de la suppression du tableau de bord`,
        edit: {
          title: `Modifier le tableau de bord`,
          nameLabel: `Nom`,
          namePlaceholder: `p. ex., Tableau de bord - 7074`,
          numberLabel: `Numéro`,
          numberPlaceholder: `p. ex., 7074`,
          omitFromDirectoryLabel: `Omettre du répertoire`,
          omitNo: `Non`,
          omitYes: `Oui`,
          cancel: `Annuler`,
          submit: `Mettre à jour le tableau de bord`,
        },
      },
      edit: {
        loading: `Chargement du tableau de bord...`,
        notFound: {
          title: `Tableau de bord introuvable`,
          errorLoading: `Erreur lors du chargement du tableau de bord : {{message}}`,
          description: `Le tableau de bord avec l'extension {{extensionDialPlan}} n'existe pas dans l'API.`,
          thisCouldMean: `Cela pourrait signifier :`,
          reasonDeleted: `Le tableau de bord a été supprimé`,
          reasonNoData: `L'extension existe mais n'a pas de données de tableau de bord`,
          reasonCorrupted: `Les données sont corrompues et ne peuvent pas être récupérées`,
          backToList: `← Retour à la liste des tableaux de bord`,
          unknownError: `Erreur inconnue`,
        },
        save: {
          cannotSave: `Impossible d'enregistrer le tableau de bord`,
          success: `Tableau de bord enregistré`,
          failed: `Échec de l'enregistrement du tableau de bord`,
          requiredFieldError: `{{node}} : {{message}}`,
          unexpectedError: `Une erreur inattendue s'est produite.`,
          targetMismatch: `Le standard chargé ne correspond pas à cette page. Actualisez avant d'enregistrer.`,
        },
        header: {
          backToList: `Retour aux standards`,
          defaultName: `Standard {{extensionDialPlan}}`,
          deleteSwitchboard: `Supprimer le standard`,
          save: `Enregistrer`,
          revertLocalChanges: `Annuler les modifications locales`,
          refreshSwitchboard: `Actualiser le standard`,
        },
        oldFormat: {
          warning: `⚠️ Avertissement : Les données du tableau de bord sont dans l'ancien format`,
          description: `Ce tableau de bord a été créé avec l'ancien éditeur. Le flux visuel ne peut pas être affiché tant qu'il n'est pas migré vers le nouveau format.`,
        },
        routeConflict: {
          title: `Conflit de routage`,
          description: `{{node}} → {{route}} a plusieurs destinations. Supprimez-en une avant d'enregistrer.`,
        },
        unconfiguredSchedule: {
          description: `Un nœud Horaire dans ce flux d'appels n'a aucun horaire sélectionné. Sélectionnez un horaire avant d'enregistrer ou déconnectez le nœud.`,
          descriptionPlural: `{{count}} nœuds Horaire dans ce flux d'appels n'ont aucun horaire sélectionné. Sélectionnez un horaire pour chacun avant d'enregistrer ou déconnectez-les.`,
        },
        canvas: {
          emptyTitle: `Aucun flux configuré pour le moment`,
          emptyDescription: `Cliquez sur « Ajouter un nœud » pour commencer à créer votre flux d'appels`,
          validationToastTitle: `Avertissement !`,
          invalidConnection: `Connexion invalide`,
        },
        unsavedChanges: {
          title: `Modifications non enregistrées`,
          body: `Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?`,
          stay: `Rester`,
          save: `Enregistrer`,
          leave: `Quitter`,
        },
        revert: {
          title: `Annuler les modifications locales ?`,
          body: `Cela supprime les modifications faites dans cette session du navigateur et recharge votre dernier standard enregistré. Cela ne supprimera pas ce qui est déjà enregistré.`,
          cancel: `Annuler`,
          confirm: `Annuler les modifications`,
          success: `Modifications locales annulées`,
          successDescription: `Votre dernier standard enregistré a été restauré.`,
        },
        versionConflict: {
          title: `De nouvelles mises à jour sont disponibles`,
          body: `Quelqu'un d'autre a enregistré des modifications sur ce standard. Conservez vos modifications actuelles ou chargez la dernière version enregistrée.`,
          keepWorking: `Conserver mes modifications`,
          loadLatest: `Charger les dernières modifications`,
        },
        refresh: {
          newerVersionTitle: `Standard actualisé`,
          newerVersionDescription: `Une version enregistrée plus récente a été détectée et chargée.`,
        },
        configPanel: {
          title: `Configurer {{type}}`,
          notImplemented: `L'interface de configuration pour ce type de nœud n'est pas encore implémentée.`,
          cancel: `Annuler`,
          save: `Enregistrer`,
        },
      },
      nodeLabels: {
        start: `DÉMARRER`,
        transfer: `Transférer`,
        transfer_and_continue: `Transférer et continuer`,
        queue: `File d'attente`,
        auto_attendant: `Répondeur automatique`,
        external_transfer: `Transfert externe`,
        leave_voicemail: `Laisser un message vocal`,
        schedule: `Horaire`,
        day_night: `Jour/Nuit`,
        dial_by_name: `Composer par nom`,
        sound_clip: `Extrait sonore`,
        wait: `Attendre`,
        hang_up: `Raccrocher`,
        jump_to_switchboard: `Aller au tableau de bord`,
        conference_room: `Salle de conférence`,
        transfer_and_rollover: `Transfert et report`,
        call_distribution: `Distribution des appels`,
        change_caller_id: `Changer l'identifiant d'appel`,
        webhook: `Webhook`,
        interactive_webhook: `Webhook interactif`,
        fax_detect: `Détection de télécopieur`,
        sms_notification: `Notification SMS`,
        ai_agent_v1: `Agent IA`,
      },
      dialogs: {
        deleteNode: {
          title: `Supprimer le nœud`,
          body: `Êtes-vous sûr de vouloir supprimer ce nœud ?`,
          bodyWithLabel: `Êtes-vous sûr de vouloir supprimer « {{label}} » ?`,
          warning: `Cette action est irréversible. Toutes les connexions à ce nœud seront également supprimées.`,
          cancel: `Annuler`,
          confirm: `Supprimer`,
        },
        deleteEdge: {
          title: `Supprimer la connexion`,
          body: `Êtes-vous sûr de vouloir supprimer cette connexion ?`,
          warning: `Cette action est irréversible.`,
          cancel: `Annuler`,
          confirm: `Supprimer`,
        },
        deleteSwitchboard: {
          title: `Supprimer le tableau de bord`,
          body: `Êtes-vous sûr de vouloir supprimer ce tableau de bord ?`,
          bodyWithName: `Êtes-vous sûr de vouloir supprimer « {{name}} » ?`,
          bodyWithId: `Êtes-vous sûr de vouloir supprimer le tableau de bord {{id}} ?`,
          warning: `Cette action est irréversible. Toute la configuration et les données du tableau de bord seront définitivement supprimées.`,
          cancel: `Annuler`,
          confirm: `Supprimer`,
        },
      },
      core: {
        selectExtension: `Sélectionner une extension...`,
        extensionLabel: `Extension`,
        selectSchedule: `Sélectionner un horaire...`,
        scheduleLabel: `Horaire`,
        selectSoundClip: `Sélectionner un extrait sonore...`,
        soundClipLabel: `Extrait sonore`,
        selectSwitchboard: `Sélectionner un tableau de bord...`,
        switchboardLabel: `Tableau de bord`,
        selectConferenceRoom: `Sélectionner une salle de conférence...`,
        conferenceRoomLabel: `Salle de conférence`,
        selectQueue: `Sélectionner une file d'attente...`,
        queueLabel: `File d'attente`,
        selectFax: `Sélectionner une extension de télécopieur...`,
        faxLabel: `Extension de télécopieur`,
        timeoutPlaceholder: `Délai d'attente (secondes)`,
        timeoutIncrease: `Augmenter le délai`,
        timeoutDecrease: `Réduire le délai`,
        expand: `Développer`,
        minimize: `Réduire`,
        deleteNodeAria: `Supprimer le nœud`,
        drop: `Déposer`,
        drag: `Glisser`,
        unnamed: `Sans nom`,
        voicemailOptions: {
          definedByExtension: `Défini par l'extension`,
          systemGenerated: `Message d'accueil généré par le système`,
          noGreeting: `Aucun message d'accueil`,
          busy1: `Occupé-1`,
          unavailable2: `Indisponible-2`,
          custom3: `Personnalisé-3`,
          custom4: `Personnalisé-4`,
          custom5: `Personnalisé-5`,
          custom6: `Personnalisé-6`,
          custom7: `Personnalisé-7`,
          custom8: `Personnalisé-8`,
          custom9: `Personnalisé-9`,
        },
      },
      create: {
        nameRequired: `Nom requis`,
        nameRequiredDescription: `Veuillez entrer un nom pour ce tableau de bord.`,
        invalidNumber: `Numéro invalide`,
        invalidNumberDescription: `Veuillez entrer un numéro valide.`,
        invalidNumberRange: `Le numéro doit être 0 ou entre 100 et 99999.`,
        pbxIdRequired: `ID PBX requis`,
        pbxIdRequiredDescription: `L'ID PBX est requis pour créer un tableau de bord.`,
        createdSuccess: `Tableau de bord créé`,
        createFailed: `Échec de la création du tableau de bord`,
        genericError: `Une erreur s'est produite`,
        cannotAddSwitchboard: `Impossible d'ajouter le tableau de bord '{{name}}'`,
        extensionAlreadyExists: `Une extension avec le numéro '{{number}}' existe déjà.`,
        dialogTitle: `Nouveau tableau de bord`,
        close: `Fermer`,
        submitButton: `Créer un nouveau tableau de bord`,
      },
      nodes: {
        clickToConfigure: `Cliquez pour configurer`,
        defaultLabel: `Nœud`,
        none: `Aucun`,
        transfer: {
          extension: `Extension`,
          extensionHelp: `Extension vers laquelle transférer l'appel`,
          timeout: `Délai d'attente (secondes)`,
          timeoutHelp: `Délai en secondes avant de passer au nœud suivant`,
          onInvalid: `Si invalide`,
          onInvalidHelp: `Nœud vers lequel aller si l'extension est invalide`,
          onTimeout: `En cas de délai d'attente`,
          onTimeoutHelp: `Nœud vers lequel aller si le transfert dépasse le délai`,
        },
        wait: {
          duration: `Durée (secondes)`,
          selectDuration: `Sélectionner la durée...`,
          ringDuringWait: `Sonner pendant l'attente`,
        },
        hangUp: {
          noConfig: `Ce nœud met fin à l'appel. Aucune configuration nécessaire.`,
          labelOptional: `Étiquette`,
          labelPlaceholder: `Étiquette pour l'affichage`,
        },
        smsNotification: {
          missedCall: `Appel manqué`,
          custom: `Personnalisé`,
          messageType: `Type de message`,
          message: `Message`,
          messagePlaceholder: `Appel manqué de {CALLER_ID}-{CALLER_NUMBER}`,
          tooltipNotesTitle: `Notes`,
          tooltipNotesAria: `Informations sur le message SMS`,
          tooltip: {
            intro: `Créez votre propre message et intégrez les valeurs Mango. Par exemple : un appel entrant du 888-555-1212 avec un identifiant d'appel John Doe serait saisi comme`,
            exampleTemplate: `Appel manqué de {CALLER_ID}-{CALLER_NUMBER}`,
            exampleResultLeadIn: `Cela enverrait un message SMS au destinataire SMS qui apparaîtrait comme ceci`,
            exampleResult: `Appel manqué de John Doe-8885551212`,
            variablesHeading: `Variables`,
          },
          smsRecipient: `Destinataire SMS`,
          smsRecipientInfo: `Informations sur le destinataire SMS`,
          separateNumbersHint: `Séparez les numéros par une virgule pour envoyer à plusieurs destinataires`,
          or: `OU`,
          autoReplyToCaller: `Répondre automatiquement à l'appelant`,
          sendFrom: `Envoyer depuis`,
          selectSendFrom: `Sélectionner un numéro...`,
          selectMessagingGroup: `Sélectionner un groupe de messagerie...`,
          smsGroupLabel: `Groupe SMS :`,
          currentUnavailableNumber: `Valeur actuelle (indisponible) : {{value}}`,
          incomingCall: `Appel entrant`,
          voicemail: `Messagerie vocale`,
        },
        queue: {
          onEscape: `À l'échappement`,
          maxWait: `Attente max. :`,
        },
        transferAndRollover: {
          noAnswer: `Sans réponse`,
          busy: `Occupé`,
        },
        common: {
          remove: `Supprimer`,
          addOption: `+ Ajouter une option`,
          removeOption: `Supprimer l'option`,
          tooltip: {
            variablesHeading: `Variables`,
            callerIdDesc: `Le nom d'identifiant d'appel de la personne qui appelle`,
            callerNumberDesc: `Le numéro de la personne qui appelle`,
            numberDialedDesc: `Le numéro qui a été composé`,
            callUidDesc: `L'id unique de l'appel qui peut être utilisé pour consulter l'enregistrement de l'appel ultérieurement.`,
            dialedNumberNameDesc: `Le nom dans mango du numéro appelé`,
            timeUtcDesc: `L'heure de l'appel dans le fuseau horaire UTC`,
          },
        },
        schedule: {
          open: `Ouvert`,
          closed: `Fermé`,
          holiday: `Férié`,
        },
        aiAgent: {
          agentId: `ID de l'agent`,
          agentIdPlaceholder: `Entrez l'UUID (36 caractères)`,
          onError: `En cas d'erreur`,
          selectAgent: `Sélectionner un agent...`,
          noAgents: `Aucun agent configuré`,
        },
        externalTransfer: {
          transferCompany: `Entreprise de transfert`,
          noCompany: `--`,
          searchTransferCompany: `Rechercher des entreprises de transfert...`,
          searchTransferCompanyAriaLabel: `Rechercher des entreprises de transfert`,
          noTransferCompanyMatches: `Aucune entreprise de transfert ne correspond à votre recherche.`,
          number: `Numéro`,
          enterPhoneNumber: `Entrez le numéro de téléphone`,
          phoneNumberExactDigitError: `Le numéro de téléphone doit comporter exactement {{count}} chiffres`,
          phoneNumberDigitRangeError: `Le numéro de téléphone doit comporter entre {{min}} et {{max}} chiffres`,
          sipServer: `Serveur SIP`,
          enterSipServer: `Entrez le serveur SIP`,
          passThroughCallerId: `Transmettre l'identifiant d'appel`,
          orUseThisCallerId: `Ou utiliser cet identifiant d'appel`,
          selectCallerId: `Sélectionner l'identifiant d'appel...`,
          noPhoneNumbersAvailable: `Aucun numéro de téléphone disponible`,
          requireOneToConnect: `Exiger 1 pour connecter`,
        },
        callDistribution: {
          weight: `Poids`,
          weightWarning: `Attention ! Le pourcentage total du poids doit être 100. Actuellement {{total}}`,
        },
        changeCallerId: {
          callerId: `Identifiant d'appel`,
          enterCallerId: `Entrez l'identifiant d'appel`,
          addUpTo20Chars: `Ajouter jusqu'à 20 caractères au début`,
          replaceCallerId: `Remplacer l'identifiant d'appel`,
        },
        dialByName: {
          invalid: `Invalide`,
          lookupBy: `Rechercher par`,
          extensionName: `Nom d'extension`,
          userName: `Nom d'utilisateur`,
          sortOrder: `Ordre`,
          firstName: `Prénom`,
          lastName: `Nom de famille`,
          firstLastName: `Prénom/Nom`,
        },
        leaveVoicemail: {
          message: `Message`,
        },
        autoAttendant: {
          repeatTimes: `Nombre de répétitions`,
          allowExtensionDialing: `Permettre la composition par extension`,
          press: `Appuyer`,
        },
        dayNight: {
          whenOpen: `Quand ouvert`,
          whenClosed: `Quand fermé`,
          open: `OUVERT`,
          closed: `FERMÉ`,
          pressToToggle: `(Appuyer sur {{code}} pour basculer)`,
          basic: `De base`,
          advanced: `Avancé`,
          toggleCode: `Code de bascule`,
          toastSuccess: `Statut jour/nuit du PBX mis à jour avec succès`,
          toastFailed: `Échec de la mise à jour du statut jour/nuit du PBX`,
        },
        webhook: {
          tooltipTitle: `Que faire ?`,
          tooltipAria: `Informations sur le webhook`,
          notifyUrl: `URL de notification`,
          notifyUrlPlaceholder: `http://www.example.com/mango_notification.php`,
          tooltip: {
            intro: `Utilisez cette fonction pour envoyer des notifications à un site Web ou serveur externe`,
            exampleUsesHeading: `Exemples d'utilisation :`,
            exampleUse1: `Notification de popup d'écran`,
            exampleUse2: `Enregistrer les appels`,
            exampleUse3: `Déclencher une action sur un autre site`,
            exampleUse4: `Créer des prospects`,
            exampleUrlHeading: `URL d'exemple`,
            curlyBracketsNote: `Les accolades seront remplacées par MangoVoice par les données réelles.`,
          },
        },
        interactiveWebhook: {
          tooltipAria: `Informations sur le webhook interactif`,
          url: `URL`,
          urlPlaceholder: `http://www.example.com/webhook`,
          allowExtensionAsOption: `Permettre l'extension comme option`,
          option: `Option`,
          optionPlaceholder: `Option`,
          tooltip: {
            intro: `Les webhooks interactifs permettent le routage en temps réel entre Mango et votre logiciel.`,
            howItWorksHeading: `Comment ça fonctionne :`,
            howItWorksBody: `Mango effectuera une requête GET vers l'URL définie. Nous remplacerons toutes les variables {} par les données réelles. Vous pouvez utiliser les paramètres dans la requête pour décider comment router l'appelant. Cela se fait en renvoyant une réponse avec l'option vers laquelle vous souhaitez que Mango route l'appel. Cela permet le routage en temps réel des appelants.`,
            exampleCasesHeading: `Cas d'exemple :`,
            exampleCase1: `Routage basé sur les compétences`,
            exampleCase2: `Router les clients vers l'agent qui a géré l'appel initial`,
            exampleCase3: `Personnaliser l'itinéraire d'appel pour les appelants récurrents.`,
            exampleRequestHeading: `Exemple de requête`,
            responseNote: `La valeur d'option dans la réponse doit correspondre aux options définies sur cet objet ; vous pouvez également renvoyer un numéro d'extension.`,
            exampleResponseHeading: `Exemple de réponse`,
            exampleResponseBody: `{"status": "success", "option": "1"}`,
          },
        },
      },
    },

    schedule: scheduleFrCa,

    global: {
      close: `Fermer`,
      clearSearch: `Effacer la recherche`,
      tooltip: {
        copyLink: `Copier le lien dans le presse-papiers`,
        copyLinkAt: `Copier le lien à {{timeStamp}}`,
        copyLinkText: `Copier le lien`,
      },
      toast: {
        moveSuccess: `Messagerie vocale déplacée avec succès.`,
        moveError: `Échec du déplacement de la messagerie vocale.`,
        deleteSuccess: `Messagerie vocale supprimée avec succès.`,
        deleteError: `Échec de la suppression de la messagerie vocale.`,
        markUnreadSuccess: `Messagerie vocale marquée comme non lue.`,
        markUnreadError: `Échec du marquage de la messagerie vocale comme non lue.`,
        copyLinkSuccess: `Lien copié dans le presse-papiers`,
        copySuccess: `Copié dans le presse-papiers`,
        copyError: `Impossible de copier dans le presse-papiers`,
        extensionSwitched: `Extension changée pour:`,
        pbxChanged: `PBX changé pour:`,
        globalPhoneHotKeySuccess: `Raccourci clavier du téléphone global enregistré avec succès.`,
        globalPhoneHotKeyError: `Échec de l'enregistrement du raccourci clavier du téléphone global.`,
        globalPhoneHotKeyDisabled: `Raccourci clavier désactivé.`,
        globalPhoneHotKeyEnabled: `Raccourci clavier activé.`,
      },
      input: {
        defaultPlaceholder: `Écrire ici`,
      },
      timeAgo: {
        justNow: `à l'instant`,
        minutesAgo_one: `il y a {{count}} min`,
        minutesAgo_other: `il y a {{count}} mins`,
        hoursAgo_one: `il y a {{count}} heure`,
        hoursAgo_other: `il y a {{count}} heures`,
        daysAgo_one: `il y a {{count}} jour`,
        daysAgo_other: `il y a {{count}} jours`,
      },
      currency: {
        default: `{{value, currency}}`,
        withCode: `{{value, currency, currencyCode}}`,
      },
    },

    contactSearchInput: {
      placeholder: `Entrer un nom ou un numéro`,
      invalidPhoneNumber: `Numéro de téléphone invalide`,
      noNumber: `Aucun numéro`,
    },

    newCallModal: {
      header: `Nouvel appel`,
      sendToWebPhone: `Envoyer au téléphone web`,
      sendToDeskPhone: `Envoyer au téléphone de bureau (Yealink)`,
      from: `De`,
      to: `À`,
      answerHandsetWhenItRings: `Décrochez votre téléphone quand il sonne.`,
      attemptingToEstablishCallTo:
        "Tentative d'établir un appel vers {{phoneNumber}}...",
      checkInternetConnection: `Veuillez vérifier votre connexion internet et réessayer.`,
      tryAgain: `Réessayer`,
      establishingCallTo: "Établissement de l'appel vers {{phoneNumber}}...",
      failedToEstablishCallTo:
        "Échec de l'établissement de l'appel vers {{phoneNumber}}.",
    },

    confirmBlockNumberModal: {
      title: `Bloquer {{formattedPhoneNumber}}`,
      message:
        "Votre PBX ne recevra plus d'appels, de textos ou de télécopies de ce numéro.",
      confirmText: `Bloquer le numéro`,
      cancelText: `Annuler`,
      toastBlockError: `Un problème est survenu lors du blocage de {{formattedPhoneNumber}}, veuillez réessayer.`,
      toastUnblockError: `Un problème est survenu lors du déblocage de {{formattedPhoneNumber}}, veuillez réessayer.`,
    },

    blockedNumbers: {
      addNumber: `Ajouter un numéro`,
      headerSubtext: `Tous les appels, textos et télécopies des numéros ci-dessous seront bloqués.`,
      header: `Numéros bloqués`,
      clearButton: `Effacer`,
      blockButton: `Bloquer le numéro`,
      modalSubtext: `Tous les appels, textos et télécopies des numéros ci-dessous seront bloqués.`,
      noBlockedNumbers: `Aucun numéro bloqué trouvé.`,
      unblockTooltip: `Débloquer`,
      unblockNumberLabel: `Débloquer {{formattedPhoneNumber}}`,
      numberUnblocked: `{{formattedPhoneNumber}} débloqué`,
      confirmUnblock: {
        title: `Débloquer {{formattedPhoneNumber}}?`,
        message: `Votre PBX recevra de nouveau les appels, textos et télécopies de ce numéro.`,
        confirmText: `Débloquer le numéro`,
        cancelText: `Annuler`,
      },
    },
    a11y: {
      messages: {
        senderContact: `Contact`,
        senderYou: `Vous`,
        senderTeam: `Votre équipe`,
        messageMeta: `{{sender}}, {{time}} :`,
        newMessage: `Nouveau message de {{sender}} : {{body}}`,
        newMessages: `{{count}} nouveaux messages de {{sender}}`,
        attachment: `Pièce jointe`,
        messageSent: `Message envoyé`,
        messageFailed: `Échec de l’envoi du message. Vous pouvez réessayer.`,
        openImage: `Ouvrir l’image {{name}}`,
        imageFrom: `Image de {{sender}}`,
        downloadFile: `Télécharger {{name}}`,
      },
      composer: {
        label: `Message`,
        labelWithName: `Message à {{name}}`,
      },
      toast: {
        close: `Fermer`,
      },
      nav: {
        notificationCount: `{{count}} nouveaux`,
      },
      filterGroup: {
        text: `Filtre des textos`,
        voicemail: `Filtre de la messagerie vocale`,
        fax: `Filtre des télécopies`,
        snippets: `Filtre des extraits`,
      },
      recipient: {
        label: `Nom ou numéro du destinataire`,
        listLabel: `Contacts suggérés`,
        results: `Contacts trouvés : {{count}}`,
      },
    },

    messageInput: {
      statusMessage: {
        uploading: `Téléchargement...`,
        failedToUpload: `Échec du téléchargement`,
      },
      attachMedia: `Joindre un média`,
      addSnippet: `Ajouter un extrait`,
      emojis: `Émojis 😃`,
      sendText: `Envoyer le texte`,
      inputPlaceholder: `Envoyez un message ici`,
      retry: `Réessayer`,
    },

    messagingPage: {
      emptyDetailViewMessage: `Aucun fil de discussion sélectionné`,
      errorToastMessage: `Numéro de téléphone invalide`,
      textPlaceholder: {
        receivedFile: `Fichier reçu`,
        fileSent: `Fichier envoyé`,
      },
      subheadingText: `{{phoneNumber, phone}} de`,
    },

    newFaxModal: {
      header: `Nouvelle télécopie`,
      footer: {
        sendButtonText: `Envoyer`,
      },
      loadingView: {
        sendingFax: `Envoi de la télécopie...`,
      },
    },

    newFaxForm: {
      dropdownPlaceholder: `De...`,
      textAreaPlaceholder: `Entrez une note de page de garde`,
      switchText: {
        includeCoverPage: `Inclure la page de garde`,
        sendEmailConfirmation: `Envoyer la confirmation par courriel`,
      },
      dropzonePlaceholder: "Vous pouvez envoyer des télécopies jusqu'à 25 Mo",
      tagInputPlaceholder: `Entrez l'adresse courriel et appuyez sur "Entrée"`,
      tagInputGuideText:
        "Vous pouvez soumettre jusqu'à {{maxEmailConfirmations}} adresses courriel",
      coverPageNoteLabel: `Note de la page couverture`,
      emailConfirmationsLabel: `Courriels de confirmation`,
      emailValueType: `courriel`,
    },

    sizeGauge: {
      totalSize: `Taille totale: {{totalSize}} / {{sizeLimit}}`,
      exceededSize: `Dépassé de {{exceededSize}}`,
    },

    contentDefault: {
      placeholder: `Glissez-déposez le fichier ici, ou cliquez pour parcourir`,
    },

    contentAcceptedMulti: {
      previewFile: `Aperçu de {{fileName}}`,
      removeFile: `Retirer {{fileName}}`,
      fileRemoved: `{{fileName}} retiré`,
      moveUp: `Déplacer {{fileName}} vers le haut`,
      moveDown: `Déplacer {{fileName}} vers le bas`,
      fileMoved: `{{fileName}} déplacé à la position {{position}} sur {{total}}`,
      possibleDuplicate: `Doublon possible`,
      tooLarge: `Trop volumineux`,
      possibleDuplicateAndTooLarge: `Doublon possible, trop volumineux`,
      fileWithStatus: `{{file}} – {{status}}`,
    },

    newThreadModal: {
      header: {
        newThread: `Nouveau fil de discussion`,
        noGroupFound: `Aucun groupe trouvé`,
      },
      sendButtonText: `Envoyer`,
      contactText1:
        "Cette extension ne fait pas partie d'un groupe de messagerie.",
      contactText2: `Rendez-vous sur {{adminUrl}} et configurez votre groupe de messagerie, ou contactez votre administrateur Mango`,
      contactLinkText: "Qu'est-ce qu'un groupe de messagerie?",
      placeholder: `Votre message`,
    },

    deleteConfirmModal: {
      title: `Supprimer la messagerie vocale?`,
      message: `Ceci est permanent et ne peut être annulé.`,
      deleteButton: `Supprimer`,
      cancelButton: `Annuler`,
    },

    confirmModal: {
      defaultTitle: `Êtes-vous sûr?`,
      confirmDeleteVoicemail: `La suppression de cette messagerie vocale est permanente et ne peut être annulée.`,
      dontAskAgain: `Ne plus demander`,
    },

    emptySearch: {
      shoot: `Oups.`,
      nothingIsMatching: `Rien ne correspond`,
      didYouSpellItRight: "L'avez-vous bien orthographié?",
    },

    listItem: {
      unreadStatus: `Non lu`,
      markedAsUnread: `Marqué comme non lu`,
      markedAsRead: `Marqué comme lu`,
    },

    messageThreadHeader: {
      rename: `Renommer`,
      cancel: `Annuler`,
      threadNameLabel: `Nom de la conversation`,
    },

    dropZoneMappings: {
      fileToLarge: {
        title: `Fichier trop volumineux`,
        description: `Il semble que le fichier que vous essayez de télécharger soit trop volumineux. La taille maximale du fichier est de {{maxFileSize}} Mo`,
      },
      fileInvalidType: {
        link: `En savoir plus`,
        title: `Type de fichier non pris en charge`,
        faxDescription: `Il semble que ce fichier soit d'un type non pris en charge. {{link}} sur les types de fichiers pris en charge`,
        description: `Il semble que ce fichier soit d'un type non pris en charge. En savoir plus sur les types de fichiers pris en charge à {{urlLink}}`,
      },
      fileUploadFailed: {
        title: `Échec du téléchargement`,
        description:
          "Il semble que le fichier que vous essayez de télécharger n'ait pas pu être téléchargé. Veuillez réessayer.",
      },
      general: {
        title: `Une erreur inattendue est survenue`,
        description: `Une erreur inattendue est survenue, veuillez réessayer.`,
      },
    },

    messageThreads: {
      emptyState: {
        title: `Aucun texte`,
        subtitle1: "Vous n'avez pas encore envoyé ou reçu de textes",
        subtitle2: `Envoyez un texte pour commencer`,
      },
      searchPlaceholder: `Rechercher un nom ou un numéro`,
      searchLabel: `Rechercher des messages`,
      allGroups: `Tous les groupes`,
      new: `{{count}} Nouveau - voir tout`,
      markAllRead: `Marquer tout comme lu`,
      buttonText: `Nouveau texte`,
    },

    phoneOptions: {
      recent: `Récents`,
      missed: `Manqués`,
    },

    chatOptions: {
      recent: `Récents`,
      unread: `Non lus`,
    },

    snippetOptions: {
      pbx: `PBX`,
      personal: `Personnel`,
    },

    chatMenu: {
      label: `Extraits`,
      settings: `Paramètres des extraits`,
    },

    phoneMenu: {
      label: `Réponse automatique`,
    },

    generalMenu: {
      label: `Envoyer des commentaires`,
    },

    experimentsMenu: {
      label: `Téléphone web`,
    },

    developMenu: {
      notifications: `Notifications`,
      contacts: `Contacts`,
    },

    callState: {
      inboundAnswered: `Répondu (entrant)`,
      outboundAnswered: `Répondu (sortant)`,
      inboundMissedOrDeclined: `Manqué ou refusé (entrant)`,
      outboundMissedOrDeclined: `Manqué ou refusé (sortant)`,
    },

    voicemailState: {
      received: `Vous avez reçu un message vocal`,
      sent: `Vous avez laissé un message vocal`,
    },

    voicemailOptions: {
      recent: `Récents`,
      unread: `Non lus`,
    },

    mangoPhoneTypes: {
      mobile: `Mobile`,
      work: `Travail`,
      home: `Domicile`,
    },

    mangoContactTypes: {
      mango: `Mango Voice`,
    },

    markReadModal: {
      header: `Attention - Marquer tout comme lu`,
      message: `Marquer tous les fils comme lus ne peut être annulé`,
      confirmText: `Êtes-vous sûr?`,
      confirmButton: `Confirmer`,
    },

    faxViewList: {
      titleNoFaxes: `Aucune télécopie`,
      titleNoMatchingFaxes: `Aucune télécopie correspondante`,
      subtitleTryRemovingFilters: `Essayez de supprimer des filtres`,
      subtitleNoFaxes: "Il semble que vous n'ayez aucune télécopie.",
      buttonTextStartFax: `Envoyer une télécopie`,
      buttonTextStartFirstFax: `Envoyer votre première télécopie`,
      searchPlaceholder: `Rechercher un nom ou un numéro`,
      searchLabel: `Rechercher des télécopies`,
      status: {
        failed: `Échec`,
        pending: `Traitement`,
        sent: `Envoyé`,
        received: `Reçu`,
        unknown: `Inconnu`,
      },
    },

    pdfToolbar: {
      print: `Imprimer`,
      download: `Télécharger`,
      openInNewTab: `Ouvrir dans un nouvel onglet`,
      firstPage: `Première page`,
      previousPage: `Page précédente`,
      nextPage: `Page suivante`,
      lastPage: `Dernière page`,
      rotate: `Pivoter`,
      pageStatus: `Page {{pageNumber}} sur {{pages}}`,
    },

    toolbar: {
      clearAll: `Tout effacer`,
      potentialDuplicates: `Doublons potentiels`,
    },

    call: {
      toast: {
        callDeclined: `Appel de {{context}} refusé`,
        callEnded: `Appel avec {{context}} terminé`,
        callHeld: `Appel avec {{context}} en attente`,
        callParked: `{{callName}} transféré à {{parkingLotName}}`,
        callParkFailed: `Échec du stationnement de {{callName}} dans {{parkingLotName}}`,
        callTargetUndialable: `Impossible d'appeler {{target}} : vérifiez le numéro et réessayez`,
        callTransferred: `{{callName}} transféré à {{transferToName}}`,
        callTransferFailed: `Échec du transfert de {{callName}} vers {{transferToName}}`,
        callUnavailable: `Téléphone déconnecté - impossible de passer l'appel`,
      },
    },

    incomingCallModal: {
      newCallFrom: `Nouvel appel de`,
      rejectCall: "Rejeter l'appel",
      acceptCall: "Accepter l'appel",
      endAndAccept: `Terminer et accepter`,
      holdAndAccept: `Mettre en attente et accepter`,
      parkAndAccept: `Parquer et accepter`,
    },

    popupCallButtons: {
      accept: `Accepter`,
      reject: `Rejeter`,
      endAndAccept: `Terminer et Accepter`,
      holdAndAccept: `Mettre en Attente et Accepter`,
      parkAndAccept: `Parquer et Accepter`,
      switch: `Basculer`,
      resume: `Reprendre`,
      end: `Terminer`,
      tooltip: {
        accept: `Accepter l'appel entrant`,
        reject: `Rejeter l'appel entrant`,
        endAndAccept: `Terminer l'appel actuel et accepter l'appel entrant`,
        holdAndAccept: `Mettre l'appel actuel en attente et accepter l'appel entrant`,
        parkAndAccept: `Parquer l'appel actuel et accepter l'appel entrant`,
        switch: `Basculer vers cet appel`,
        resume: `Reprendre cet appel`,
        end: `Terminer cet appel`,
      },
    },

    callStatus: {
      deskPhone: `Téléphone de Bureau`,
      onHold: `En Attente`,
      ringing: `Sonnerie`,
      connected: `Connecté`,
      connecting: `Connexion`,
      ready: `Prêt`,
      dialing: `Numérotation...`,
      reconnecting: `Reconnexion...`,
      onDeskPhone: `Au téléphone de bureau`,
      connectedWithDuration: `Connecté {{duration}}`,
      shortDial: `Composer`,
      shortRing: `Sonnerie`,
      shortHold: `Attente`,
      shortConn: `Conn.`,
      shortDesk: `Bureau`,
    },

    callAnnouncements: {
      incomingCall: `Appel entrant de {{name}}, {{number}}`,
      incomingCallNameOnly: `Appel entrant de {{name}}`,
      connected: `Connecté`,
      onHold: `En attente`,
      resumed: `Appel repris`,
      muted: `Micro coupé`,
      unmuted: `Micro réactivé`,
      callEnded: `Appel terminé`,
      answerFailed: `Impossible de répondre à l'appel`,
      holdFailed: `Impossible de mettre l'appel en attente`,
      resumeFailed: `Impossible de reprendre l'appel`,
    },

    callSoundIndicator: {
      onHold: `En Attente`,
      muted: `Muet`,
      reconnecting: `Reconnexion`,
    },

    popup: {
      tabs: {
        inboundCalls: `Appels Entrants`,
        messages: `Messages`,
      },
      emptyStates: {
        noCalls: {
          title: `Aucun appel trouvé`,
          description: `Il n'y a actuellement aucun appel entrant disponible`,
        },
        noActiveCalls: `Aucun appel actif`,
        noMessages: {
          title: `Aucun message trouvé`,
          description: `Il n'y a actuellement aucun message disponible`,
        },
      },
      footer: {
        poweredByMango: `Propulsé par Mango Voice`,
      },
      callButtons: {
        deskPhoneActive: `Appel actif sur le téléphone de bureau`,
        dismiss: `Ignorer`,
      },
      callItem: {
        unknownCaller: `Appelant Inconnu`,
        unknownNumber: `Numéro Inconnu`,
        onHold: `En Attente`,
        pageIntercom: `Appel général/Interphone`,
        callDetails: `Détails de l'appel`,
      },
      messageButtons: {
        dismiss: `Ignorer`,
        openMessage: `Ouvrir le Message`,
      },
      personCard: {
        patientFile: `Dossier du Patient`,
        fullName: `Nom Complet`,
        dateOfBirth: `Date de Naissance`,
        patientNumber: `Numéro du Patient`,
        inboundNumber: `Numéro Entrant`,
        extension: `Extension`,
        defaultLocation: `Emplacement par Défaut`,
        nextAppointment: `Prochain Rendez-vous`,
        previousAppointment: `Rendez-vous Précédent`,
        insurance: `Assurance`,
        balance: `Solde`,
      },
      header: {
        expand: `Agrandir`,
        minimize: `Réduire`,
        dismiss: `Ignorer`,
        logoAlt: `Logo`,
      },
    },

    faxPage: {
      toast: {
        copyLinkSuccess: `Lien copié dans le presse-papiers`,
        copyLinkError: `Échec de la copie du lien dans le presse-papiers.`,
        sendSuccess:
          "Votre télécopie a été ajoutée à la file d'attente et sera envoyée sous peu",
        sendError:
          "Un problème est survenu lors de l'envoi de votre télécopie. Veuillez réessayer",
        deleteSuccess: `Télécopie supprimée avec succès`,
        deleteError: `Un problème est survenu lors de la suppression de cette télécopie. Veuillez réessayer`,
        unexpectedError: `Une erreur inattendue s'est produite`,
      },
      confirmDelete: {
        title: `Supprimer la télécopie`,
        message: `Êtes-vous sûr de vouloir supprimer cette télécopie?`,
        button: `Supprimer`,
        cancel: `Annuler`,
      },
      confirmResend: {
        title: `Renvoyer la télécopie`,
        message: `Êtes-vous sûr de vouloir renvoyer cette télécopie?`,
        button: `Renvoyer`,
        cancel: `Annuler`,
      },
      emptyStateMessage: `Aucune télécopie sélectionnée`,
      status: {
        queued: "En file d'attente",
        received: `Reçu`,
        sent: `Envoyé`,
      },
      direction: {
        to: `À`,
        from: `De`,
      },
      detailsHeader: {
        status: `{{statusPrefix}} le {{statusDate}} à {{statusTime}} {{directionText}}`,
      },
    },

    secureFaxPage: {
      logoAlt: `Mango Voice logo`,
      loading: {
        title: `Vérification du lien de fax sécurisé`,
        description: `Veuillez patienter pendant que nous vérifions ce lien de fax sécurisé.`,
      },
      password: {
        title: `Accès au fax sécurisé`,
        description: `Saisissez le mot de passe du fax sécurisé pour accéder à ce fax.`,
        label: `Mot de passe du fax sécurisé`,
        placeholder: `Saisissez le mot de passe`,
        submitButton: `Voir le fax sécurisé`,
        submittingButton: `Vérification du mot de passe...`,
      },
      errors: {
        password_required: `Le mot de passe est requis.`,
        invalid_password: `Le mot de passe que vous avez saisi est incorrect.`,
        s3_error: `Impossible de préparer l'aperçu du fax sécurisé. Veuillez réessayer.`,
        throttled: `Trop de requêtes. Veuillez patienter un moment et réessayer.`,
        unknown: `Une erreur s'est produite. Veuillez réessayer.`,
        attemptsRemaining: `Tentatives restantes : {{count}}`,
      },
      status: {
        expired: {
          title: `Lien expiré`,
          description: `Ce lien de fax sécurisé a expiré. Veuillez demander un nouveau lien de fax sécurisé.`,
        },
        disabled: {
          title: `Lien désactivé`,
          description: `Ce lien de fax sécurisé a été désactivé.`,
        },
        not_found: {
          title: `Lien introuvable`,
          description: `Nous n'avons pas pu trouver ce lien de fax sécurisé.`,
        },
        max_downloads_reached: {
          title: `Limite de téléchargements atteinte`,
          description: `Ce lien de fax sécurisé a atteint son nombre maximal de téléchargements.`,
        },
        too_many_attempts: {
          title: `Trop de tentatives`,
          description: `Ce lien de fax sécurisé a été verrouillé après un trop grand nombre de tentatives de mot de passe.`,
        },
        throttled: {
          title: `Trop de requêtes`,
          description: `Trop de requêtes ont été effectuées pour ce lien. Veuillez réessayer sous peu.`,
        },
        unknown: {
          title: `Impossible de charger le fax sécurisé`,
          description: `Nous n'avons pas pu vérifier ce lien de fax sécurisé.`,
        },
        actions: {
          checkAgain: `Vérifier à nouveau`,
        },
      },
      download: {
        title: `Fax sécurisé prêt`,
        description: `Votre fax sécurisé est prêt. Ce lien de téléchargement expire bientôt, alors téléchargez-le maintenant.`,
        detailsTitle: `Détails de la télécopie`,
        fromLabel: `De`,
        toLabel: `À`,
        receivedLabel: `Reçue`,
        downloadsRemainingLabel: `Téléchargements restants`,
        actions: {
          download: `Télécharger la télécopie`,
          openInNewTab: `Ouvrir dans un nouvel onglet`,
          tryAnotherPassword: `Essayer un autre mot de passe`,
        },
        fetchError: {
          title: `Impossible de charger l'aperçu`,
          description: `Nous n'avons pas pu charger l'aperçu du fax sécurisé à partir du lien de téléchargement.`,
          retryPreview: `Réessayer l'aperçu`,
          generic: `Échec du chargement de l'aperçu du fax sécurisé.`,
        },
      },
    },

    voicemail: {
      emptyState: {
        title: `Aucun message vocal`,
        subtitle1: `Il semble que vous répondez à tous vos appels. Continuez votre excellent travail!`,
        subtitle2:
          "Si vous pensez qu'il vous manque des messages vocaux, veuillez contacter notre équipe de support.",
        buttonText: `Contacter le support`,
      },
      searchPlaceholder: "Rechercher un nom ou un numéro d'appelant",
      searchLabel: `Rechercher dans la messagerie vocale`,
      emptyDetailViewMessage: `Aucun message vocal sélectionné`,

      mangoModal: {
        title: `Déplacer`,
        headerText: `Déplacer le message vocal`,
        cancelButtonText: `Annuler`,
        moveButtonText: `Déplacer le message vocal`,
        selectVoicemailBoxText: `Sélectionner la boîte vocale...`,
        markAsUnreadText: `Marquer comme non lu dans la boîte sélectionnée`,
        destinationBoxText: `Boîte vocale de destination`,
        destinationBoxWarning:
          "Ce message vocal deviendra inaccessible si vous n'avez pas accès à la boîte vocale de destination.",
      },

      detailView: {
        headerSubheadingText: `De`,
        headerSubheadingToText: `À`,
        audioPlayerTitle: `Audio du message vocal`,
        transcriptionText: `Transcription`,
      },

      loadingText: `Messagerie vocale`,
      transcriptionTitleText: `Transcription`,

      move: {
        error: `Une erreur est survenue lors du déplacement du message vocal.`,
        success: `Message vocal déplacé avec succès`,
        successMarkAsUnread: `Message vocal déplacé et marqué comme non lu avec succès`,
        successMarkAsRead: `Message vocal déplacé avec succès`,
      },

      filter: {
        all: `Tous`,
        unread: `Non lus`,
        allInboxes: `Toutes les boîtes de réception`,
      },

      tooltip: {
        move: `Déplacer`,
        delete: `Supprimer`,
        markAsUnread: `Marquer comme non lu`,
        markAsRead: `Marquer comme lu`,
        blockNumber: `Bloquer le numéro`,
        unblockNumber: `Débloquer le numéro`,
        copyLink: `Copier le lien dans le presse-papiers`,
        editContact: `Modifier le contact`,
        newCall: `Nouvel appel`,
        newText: `Nouveau texte`,
        resendFax: `Renvoyer la télécopie`,
        moveFax: `Déplacer la télécopie`,
        newFax: `Nouvelle télécopie`,
        close: `Fermer`,
      },

      copyLinkError: `Échec de la copie du lien dans le presse-papiers.`,
    },

    audioPlayer: {
      rewind10s: `Reculer de 10 s`,
      play: `Lire`,
      pause: `Pause`,
      mute: `Muet`,
      unmute: `Activer le son`,
      fastForward10s: `Avancer de 10 s`,
      jumpToAnswer: `Aller à la réponse`,
      changePlaybackSpeed: `Changer la vitesse de lecture`,
      downloadAudio: "Télécharger l'audio",
      seeKeyboardShortcuts: `Voir les raccourcis clavier`,
      mediaError: `Un problème est survenu lors du chargement de ce fichier audio.`,
      noAudio: `Aucun enregistrement disponible`,
      playbackPosition: `Position de lecture`,
      playbackPositionValue: `{{position}} sur {{duration}}`,
    },

    fax: {
      filter: {
        all: `Tous`,
        unread: `Non lus`,
        allInboxes: `Toutes les boîtes de réception`,
        sent: `Envoyés`,
        received: `Reçus`,
      },
      tooltip: {
        pending: `Cette télécopie est en cours de traitement et sera envoyée sous peu`,
      },
    },

    pbxPrompt: {
      loggingIn: `Connexion en cours...`,
      loadingPbxs: `Chargement des PBX...`,
      selectPbx: `Sélectionnez votre PBX`,
      noPbxMessage: `Vous n'êtes actuellement membre d'aucun système téléphonique (PBX). Pour utiliser cette application, veuillez contacter la personne de votre bureau qui gère le système téléphonique pour qu'elle vous ajoute.`,
      noPbxErrorMessage: `Si vous pensez qu'il s'agit d'une erreur, contactez le support Mango pour obtenir de l'aide supplémentaire.`,
      callSupport: `Appeler le support`,
      emailSupport: `Envoyer un courriel au support`,
      back: `Retour`,
      errorTitle: `Oups! Une erreur s'est produite.`,
      errorMessage: `Veuillez réessayer ou contacter le support.`,
    },

    pbxPicker: {
      searchPlaceholder: `Rechercher des PBX...`,
      current: `Actuel`,
      recent: `Récents`,
      allPbxs: `Tous les PBX`,
      searchResults: `Résultats de recherche`,
      noResults: `Aucun PBX trouvé`,
      searchPrompt: `Rechercher un PBX par nom`,
      switchPbx: `Changer de PBX`,
      count: `{{count}} PBX`,
      countFiltered: `{{count}} PBXs trouvés`,
    },

    pbxHeaderSwitcher: {
      selectPbx: `Sélectionner un PBX`,
      ariaLabel: `Changer de PBX`,
    },

    loginPrompt: {
      loginFailedError: `Échec de la connexion. Veuillez réessayer.`,
      invalidEmail: `Adresse courriel non valide!`,
      enterUsername: `Veuillez entrer le nom d'utilisateur`,
      enterPassword: `Veuillez entrer un mot de passe`,
      invalidCredentials: `Nom d'utilisateur ou mot de passe non valide, veuillez vérifier vos informations d'identification et réessayer.`,
      usernamePlaceholder: `courriel / nom d'utilisateur`,
      passwordPlaceholder: `mot de passe`,
      logIn: `Se connecter`,
      forgotPassword: `Mot de passe oublié?`,
      openSupportForm: `Ouvrir le formulaire d'assistance`,
      backToLogin: `Retour à la connexion`,
      showPassword: `Afficher le mot de passe`,
    },

    desktopAppBanner: {
      tryDesktopApp: `Essayez l'application de bureau {{appName}} pour la meilleure expérience`,
      desktopAppName: `{{appName}} Bureau`,
      launchAppTooltip: `Lancer l'application de bureau si installée`,
      downloadAppTooltip: `Télécharger l'application de bureau`,
      launchApp: `Lancer l'App`,
      download: `Télécharger`,
      settings: `Paramètres`,
      dontAskAgain: `Ne plus demander`,
      remindMeLater: `Me rappeler plus tard`,
      alwaysOpenHint: `Pour toujours ouvrir les liens dans l'application de bureau, modifiez ce réglage dans les Paramètres.`,
      launchConfirmTitle: `Ouvrir dans l'application de bureau`,
    },
    openApp: {
      title: `Ouverture de votre application de bureau…`,
      subtitle: `Nous lançons l'application maintenant. Si elle ne s'ouvre pas automatiquement, utilisez le bouton ci-dessous.`,
      closeHint: `Vous pouvez fermer cet onglet une fois l'application ouverte.`,
      openButton: `Ouvrir l'application de bureau`,
      fallbackPrompt: `Vous n'avez pas installé l'application de bureau?`,
      downloadButton: `Télécharger l'application de bureau`,
    },

    openedInDesktop: {
      title: `Nous avons tenté d'ouvrir cette page dans l'application de bureau`,
      subtitle: `Si l'application de bureau {{appName}} s'est ouverte, vous pouvez fermer cet onglet.`,
      continueInBrowser: `Continuer dans le navigateur`,
      tryAgain: `Réessayer`,
      stopOpeningInDesktop: `Ne plus ouvrir les liens dans l'application de bureau`,
      settingsHint: `Pour garder les liens dans ce navigateur, modifiez <settingsLink>Application de bureau dans les Paramètres</settingsLink>.`,
    },

    profileSettings: {
      myProfile: `Mon profil`,
      editProfile: `Modifier le profil`,
      name: `Nom`,
      username: `Nom d'utilisateur`,
      email: `Courriel`,
      openDesktopApp: `Ouvrir l'application de bureau`,
      launchDesktopApp: `Lancer l'application de bureau`,
      callSupport: `Appeler le support`,
      emailSupport: `Support par courriel`,
      sendFeedback: `Envoyer des commentaires`,
      whatsNew: `Nouveautés`,
      downloadApp: `Télécharger l'application`,
      logOut: `Déconnexion`,
      needHelp: `Besoin d'aide?`,
      switchPbx: 'Changer de PBX',
      pbxName: 'Nom du PBX',
      darkMode: `Mode Sombre`,
      darkModeOptions: {
        light: `Clair`,
        dark: `Sombre`,
        system: `Utiliser les paramètres du système`,
      },
      language: `Langue`,
      desktopApp: {
        label: `Application de bureau`,
        beta: `Bêta`,
        modeLabel: `Quand j'ouvre un lien {{appName}} dans ce navigateur`,
        modeHint: `Ce paramètre s'applique uniquement à ce navigateur.`,
        modes: {
          ask: `Me demander (afficher une bannière)`,
          always: `Toujours ouvrir dans l'application de bureau`,
          never: `Ne pas demander`,
        },
        testLaunch: {
          title: `Ouvrir les liens dans l'application de bureau`,
          question: `Nous venons d'essayer d'ouvrir l'application de bureau {{appName}}. S'est-elle ouverte?`,
          yes: `Oui, elle s'est ouverte`,
          no: `Non, elle ne s'est pas ouverte`,
          notOpened: `Les liens continueront de s'ouvrir dans ce navigateur. Installez l'application de bureau {{appName}}, puis réessayez.`,
          tryAgain: `Réessayer`,
          close: `Fermer`,
        },
      },
      switchPbxConfirmation: {
        title: `Changer votre PBX actuel`,
        message: `Les appels, les textos, les télécopies et les messages vocaux de {{pbxName}} ne seront pas disponibles sur cette application tant que vous ne revenez pas.`,
        confirmText: `Ok`,
        cancelText: `Annuler`,
      },
      editMyProfile: {
        title: `Modifier mon profil`,
        update: `Mettre à jour le profil`,
        close: `Fermer`,
        firstName: `Prénom`,
        lastName: `Nom`,
        username: `Nom d'utilisateur`,
        email: `Courriel`,
        errRequiredFirstName: `Veuillez saisir le prénom.`,
        errRequiredLastName: `Veuillez saisir le nom.`,
        successProfile: `Profil mis à jour avec succès.`,
      },
    },

    pbxQuerySwitch: {
      confirm: {
        title: `Définir ce PBX?`,
        message: `Voulez-vous définir votre PBX sur {{pbxName}}?`,
        confirmText: `Définir le PBX`,
        cancelText: `Annuler`,
      },
      warning: {
        invalid: {
          title: `Lien PBX invalide`,
          description: `Le lien PBX est invalide. Veuillez réessayer depuis Admin.`,
        },
        inaccessible: {
          title: `Impossible de changer de PBX`,
          description: `Vous n'avez pas accès à ce PBX.`,
        },
      },
    },

    languageSelector: {
      title: `Préférences de Langue`,
      selectLanguage: `Sélectionner la Langue`,
      autoDetect: `Détection Automatique (Langue du Système)`,
      languages: {
        en: `Anglais`,
        'en-US': `Anglais (États-Unis)`,
        'en-GB': `Anglais (Royaume-Uni)`,
        'en-CA': `Anglais (Canada)`,
        es: `Espagnol`,
        'es-MX': `Espagnol (Mexique)`,
        'es-US': `Espagnol (États-Unis)`,
        'fr-CA': `Français (Canada)`,
        ko: `Coréen`,
        ne: `Népalais`,
        te: `Télougou`,
      },
    },

    snippetsSettings: {
      confirmationModal: {
        title: `Êtes-vous sûr?`,
        message: `La suppression de cet extrait est permanente et ne peut être annulée`,
        confirmText: `Supprimer`,
        cancelText: `Annuler`,
      },
      errorWithTimeout:
        "Quelque chose s'est mal passé. Veuillez réessayer plus tard.",
      headerText: `Extraits`,
      newButtonText: `Nouveau`,
      tooltipDelete: `Supprimer`,
      editSnippetLabel: `Modifier l'extrait {{name}}`,
      deleteSnippetLabel: `Supprimer l'extrait {{name}}`,
      cancelEditing: `Annuler la modification`,
      dismissError: `Fermer l'erreur`,
      editSnippet: "Modifier l'extrait",
      newSnippet: `Nouvel extrait`,
      shortcut: `Raccourci`,
      inputPlaceholder: `Bonjour`,
      shortcutGuideText: `Un mot, sans espaces. ex.: #bonjour ou #ResultatsTest`,
      visibility: `Visibilité`,
      visibilityGuideText: `Personnel = seulement vous pouvez y accéder, Entreprise = tout le monde y aura accès`,
      editBodyInputPlaceholder: `Écrivez un message prédéfini ici. Vous pouvez ajouter des courriels, des liens web, des numéros de téléphone...`,
      mangoButtonCancel: `Annuler`,
      mangoButtonSave: `Enregistrer`,
      loadingSnippets: `Chargement des extraits...`,
      noSnippetsFound: `Aucun extrait trouvé`,
      body: `Corps`,
      personal: `Personnel`,
      filter: {
        all: `Tous`,
        unread: `Non lus`,
        allInboxes: `Toutes les boîtes de réception`,
      },
    },

    phoneSettings: {
      incomingCalls: `Appels entrants`,
      showInboundC2CCalls: `Afficher les appels C2C entrants`,
      playRingtone: `Jouer la sonnerie`,
      ringtone: `Sonnerie`,
      respondWithBusyToSecondCall: `Répondre occupé au deuxième appel`,
      disabledInAgentMode: `Désactivé lorsque le mode agent est activé`,
      outgoingCalls: `Appels sortants`,
      defaultOutboundPhone: `Sélectionner le téléphone par défaut pour les appels sortants`,
      autoAnswer: `Réponse automatique`,
      enableCallerIdSelection:
        "Activer la sélection de l'identifiant de l'appelant",
      enableCallerIdSelectionDescription: `Vous permet de choisir le numéro de téléphone sortant lors des appels.`,
      callerId: "Identifiant de l'appelant",
      presence: `Présence`,
      presenceDescription: `Les sections suivantes seront affichées sur votre téléphone web vous donnant un accès rapide à vos extensions et numéros les plus fréquemment composés.`,
      parkingSpotsDisplayed: `Places de stationnement affichées (Limite 5)`,
      removeParkingSpot: `Supprimer la place de stationnement`,
      addParkingSpot: `Ajouter une place de stationnement`,
      lineExtensionsDisplayed: `Extensions de ligne affichées (Limite 10)`,
      removeExtension: "Supprimer l'extension",
      addExtension: `Ajouter une extension`,
      speedDial: `Numérotation abrégée (Limite {{maxSpeedDials}})`,
      editSpeedDial: `Modifier la numérotation abrégée`,
      removeSpeedDial: `Supprimer la numérotation abrégée`,
      addSpeedDial: `Ajouter une numérotation abrégée`,
      clickToCall: `Cliquez pour appeler`,
      sendToDeskPhone: `Envoyer au téléphone de bureau (Yealink)`,
      useWebPhone: `Utiliser le téléphone web`,
    },

    phoneSettingItems: {
      selectExtension: "Sélectionner l'extension",
      yourExtension: `Votre extension`,
      activateWebPhone: `Activer le téléphone web`,
      confirmationModal: {
        title: `Aucune extension de ligne disponible`,
        message1:
          "Vous n'avez aucune extension de ligne attribuée sur ce système téléphonique ({{pbxName}}).",
        message2: `Pour utiliser la fonction téléphone, veuillez contacter votre administrateur système pour attribuer une extension de ligne.`,
        confirmText: `Ignorer`,
        cancelText: `Annuler`,
      },
    },

    extensionSelector: {
      selectExtension: `Sélectionner une nouvelle extension`,
      deactivateWebPhone: `Désactiver le téléphone web`,
      none: `Aucun`,
      confirmationModal: {
        title: "Dissocier l'appareil",
        message:
          "Cet appareil n'enverra ni ne recevra plus d'appels de {{extensionName}}.",
        confirmText: `Ok`,
        cancelText: `Annuler`,
      },
    },

    webPhone: {
      unknownCaller: `Appelant inconnu`,
      selectParkingSpot: `Sélectionner un espace de stationnement`,
      receivingCalls: `Réception des appels`,
      doNotDisturb: {
        title: `Ne pas déranger`,
        until: `Jusqu'à {{time}}`,
        indefinite: `Ne pas déranger`,
        for30Minutes: `Ne pas déranger pendant 30 minutes`,
        for1Hour: `Ne pas déranger pendant 1 heure`,
        for2Hours: `Ne pas déranger pendant 2 heures`,
        untilTomorrow: `Ne pas déranger jusqu'à demain`,
        turnOff: `Désactiver ne pas déranger`,
      },
      tooltip: {
        copied: `Copié!`,
        copyCallerId: `Copier l'ID de l'appelant`,
        copyPhoneNumber: `Copier le numéro de téléphone`,
        endCall: `Terminer l'appel`,
        muteCall: `Rendre muet`,
        answerCall: `Répondre à l'appel`,
        switchToCall: `Passer à l'appel`,
        warmTransfer: `Transfert chaud`,
        holdCall: `Mettre en attente`,
        resumeCall: `Reprendre l'appel`,
        newCall: `Nouvel appel`,
        mergeCalls: `Fusionner les appels`,
        endConference: `Terminer la conférence`,
      },
      callError: {
        youAreDisconnected: `Vous êtes déconnecté`,
        connectionInterrupted: `Votre connexion a été interrompue. Cliquez ici pour réessayer la connexion.`,
        reconnect: `Reconnecter`,
        connecting: `Connexion…`,
        connectionFailed: `Échec de la connexion téléphonique. Veuillez réessayer.`,
        retry: `Réessayer`,
        microphoneDisabled: `Les permissions du microphone sont désactivées!`,
        microphoneEnableText: `Activer la permission du microphone vous permettra d'utiliser le téléphone web.`,
        microphoneInUse: `Le microphone est en cours d'utilisation`,
        microphoneInUseText: `Une autre application utilise votre microphone. Fermez-la (par exemple Zoom, Teams ou un autre onglet) et réessayez.`,
        seeHereForHelp: `Voir ici pour de l'aide.`,
      },
      feedback: {
        reason: {
          soundDelayed: `Le son était retardé`,
          couldntHearOthers: `Je n'entendais pas les autres`,
          echo: `Il y avait de l'écho`,
          audioBreakingUp: `L'audio était haché`,
          othersCouldntHearMe: `Les autres ne m'entendaient pas`,
          otherAudioIssue: `Autre problème audio`,
        },
        modal: {
          header: `Qu'est-ce qui n'a pas fonctionné?`,
          dismiss: `Fermer`,
          submit: `Envoyer les commentaires`,
        },
        toast: {
          header: `Évaluez l'audio de votre appel`,
          thanks: `Merci!`,
          goodQuality: `Bonne qualité d'appel`,
          poorQuality: `Mauvaise qualité d'appel`,
          dismiss: `Ignorer`,
        },
      },
    },

    faxSettings: {
      enableFaxCoverPage: `Activer la page de garde de télécopie`,
    },

    notificationSettings: {
      alertMessage: `Vous avez bloqué les notifications. Vous devrez aller dans les paramètres de votre navigateur pour les réactiver.`,
      browserNotifications: `Notifications du navigateur`,
      playSoundForNewTexts: `Jouer un son pour les nouveaux textes`,
      testNotification: `Tester la notification`,
      volumeControl: `Le volume de la notification est contrôlé par votre ordinateur`,
      help: `Aide`,
      helpLinkText: `Comment activer/désactiver les notifications`,
      onGoogleChrome: `sur Google Chrome?`,
      callPop: {
        title: `Fenêtre de Notification d'Appel et de SMS`,
        description: `Essayez notre nouvelle fonctionnalité de fenêtre de notification. Cette fonctionnalité affichera une petite fenêtre séparée lorsque vous recevez un appel ou un SMS. Cela vous permet de voir les informations d'appel et de SMS sans interrompre votre travail !`,
        answerOnPatientInfoButtonClick: `Répondre à l'appel lors de l'ouverture des informations du patient`,
        showExampleButton: `Afficher l'exemple`,
        enableExampleHint: `Basculez l'interrupteur ci-dessus pour activer le bouton d'exemple`,
      },
      popupPosition: {
        title: `Position de la fenêtre contextuelle`,
        topLeft: `En haut à gauche`,
        topRight: `En haut à droite`,
        bottomLeft: `En bas à gauche`,
        bottomRight: `En bas à droite`,
      },
    },

    callInProgressModal: {
      title: `Appel en cours`,
      message: `Veuillez terminer votre appel en cours avant de changer d'extension`,
      dismiss: `Fermer`,
    },

    sessionExpiredModal: {
      title: `Votre session a expiré`,
      message: `Pour votre sécurité, vous avez été déconnecté. Les brouillons de messages texte sont conservés sur cet appareil. Reconnectez-vous pour continuer.`,
      signInAgain: `Se reconnecter`,
    },

    audioSettings: {
      selectSoundOutputSource: `Sélectionner la source de sortie audio - haut-parleurs`,
      selectInputSource: "Sélectionner la source d'entrée - microphone",
      toSelectAudioDevices: `Pour sélectionner les appareils audio, veuillez accorder les autorisations de microphone`,
    },

    integrationsSettings: {
      title: `Intégrations`,
      description: `Cette page affiche certaines de vos intégrations de sources de données — des connexions qui synchronisent les données entre Mango et votre logiciel de gestion de cabinet. Vous pouvez avoir d'autres intégrations actives qui n'apparaissent pas encore ici. Nous travaillons sur une expérience d'intégrations unifiée qui regroupera tout.`,
      configuration: `Configuration`,
      auth: `Autorisation`,
      authDescription: `Cette intégration nécessite une autorisation pour accéder à vos données.`,
      authButton: `Autoriser`,
      authRegionNotSupported: `L'autorisation n'est pas disponible dans votre région détectée. Si vous pensez que c'est incorrect (par exemple, si vous utilisez un VPN), contactez le support.`,
      agentId: `ID : {{id}}`,
      copiedConfirmation: `Copié !`,
      copyIdFailedTitle: `Impossible de copier l'ID`,
      unknownDate: `(inconnu)`,
      statusActive: `Actif`,
      statusPaused: `En pause`,
      createdLabel: `Créé`,
      updatedLabel: `Mis à jour`,
      notSet: `(non défini)`,
      enabled: `Activé`,
      disabled: `Désactivé`,
      accessRestricted: `Vous n'avez pas la permission d'accéder aux intégrations. Contactez votre administrateur pour y accéder.`,
      emptyState: {
        primary: `Aucune intégration de source de données n'est encore gérée ici.`,
        secondary: `Si vous avez des intégrations actives, elles n'apparaîtront peut-être pas encore dans cette liste.`,
      },
      error: {
        title: `Échec du chargement des intégrations`,
        message: `Une erreur s'est produite lors du chargement de vos intégrations. Veuillez réessayer plus tard.`,
      },
    },

    updateSettings: {
      noExperimentsAvailable: `Aucune expérience en cours en ce moment.`,
      channelSwitcher: {
        title: `Changement de Canal de Version`,
        description: `Choisissez quelle version des mises à jour recevoir. Production a les fonctionnalités les plus stables, tandis que les autres canaux peuvent offrir un aperçu des nouvelles fonctionnalités. Changer de canal nécessite le redémarrage de l'application.`,
        devModeNote: `Mode de Développement : Le changement de canal est simulé et rechargera la page au lieu de redémarrer l'application.`,
        releaseChannel: `Canal de Version`,
        selectChannel: `Sélectionner un canal...`,
        switchChannel: `Changer de Canal`,
        rollback: `Revenir à {{channelName}}`,
        current: `Actuel : {{channelName}}`,
        switchTo: `Passer à :`,
        error: `Canal non disponible`,
        validationError: `Impossible de passer à {{channelName}}. Le canal n'est peut-être pas encore disponible ou il peut y avoir un problème réseau. Veuillez réessayer plus tard.`,
        switchFailed: `Échec du changement de canal. Veuillez réessayer.`,
        restartModal: {
          title: `Redémarrage Requis`,
          successMessage: `Basculement réussi vers le canal <strong>{{channelName}}</strong>.`,
          warningMessage: `L'application doit se mettre à jour puis redémarrer pour terminer le changement de canal. Tout travail non enregistré sera perdu.`,
          cancel: `Annuler`,
          restartNow: `Commencer le changement`,
          switchingChannel: `Passage à {{channelName}}...`,
          checkingUpdates: `Vérification des mises à jour...`,
          downloadingUpdate: `Téléchargement de la mise à jour... {{progress}}%`,
          activatingChannel: `Activation du canal...`,
          switching: `Changement en cours...`,
        },
        highRiskWarning: {
          title: `Canal Instable`,
          description: `Ce canal peut contenir des fonctionnalités expérimentales, des bogues ou des fonctionnalités incomplètes. Utilisez à vos propres risques.`,
        },
        mediumRiskWarning: {
          title: `Canal de Pré-version`,
          description: `Ce canal contient des logiciels de pré-version qui peuvent comporter des bogues ou des fonctionnalités incomplètes.`,
        },
      },
      releaseNotifications: {
        title: `Notifications de Version`,
        description: `Recevez un courriel lorsqu'une nouvelle version de l'application est publiée.`,
        descriptionWithChannel: `Recevez un courriel lorsqu'une nouvelle version de l'application est publiée sur le canal {{channel}}.`,
        toggleLabel: `M'envoyer un courriel au sujet des nouvelles versions`,
        recipient: `Les notifications seront envoyées à l'adresse courriel associée à votre compte.`,
        recipientWithEmail: `Les notifications seront envoyées à {{email}}.`,
        resubscribeNote: `Vous vous êtes désabonné précédemment. Activer cette option réabonnera votre courriel aux courriels de nouveautés de version.`,
        error: `Impossible de mettre à jour votre paramètre de notification. Veuillez réessayer.`,
        loadError: `Impossible de charger votre paramètre de notification.`,
        retry: `Réessayer`,
        previewButton: `Aperçu du courriel`,
        previewModalTitle: `Exemple de courriel de version`,
        previewModalNote: `Un exemple de ce que vous recevrez. Le contenu réel varie selon la version. Les courriels sont envoyés en anglais.`,
        previewFrom: `De :`,
        previewSubject: `Objet :`,
        previewClose: `Fermer`,
        previewTipsTitle: `Assurez-vous de recevoir ces courriels`,
        previewSenderTip: `Les courriels proviennent de :`,
        previewTipContacts: `Ajoutez cette adresse à vos contacts ou à votre carnet d'adresses.`,
        previewTipJunk: `Si vous ne voyez pas de courriel après une version, vérifiez votre dossier de pourriels ou courrier indésirable et marquez-le comme « Non indésirable ».`,
        previewTipSafelist: `Sur un compte professionnel, demandez à votre administrateur TI d'ajouter le domaine mangovoice.com à la liste des expéditeurs autorisés.`,
      },
    },

    blockedNumberModal: {
      header: `Bloquer le numéro`,
      description: `Tous les appels, textos et télécopies de ce numéro seront bloqués.`,
      clearButton: `Effacer`,
      blockButton: `Bloquer le numéro`,
      inputPlaceholder: `Entrez le numéro de téléphone`,
      inputLabel: `Numéro de téléphone à bloquer`,
    },

    callCenterSettings: {
      enableAgentMode: `Activer le mode agent`,
      customStatuses: "Statuts d'agent personnalisés",
      customStatusesDescription:
        "Configurez des statuts personnalisés pour suivre les activités en dehors de la file d'attente des appels, comme les déjeuners, les pauses, les réunions, et plus encore. Gardez l'activité de votre équipe organisée et visible.",
      editStatus: `Modifier le statut`,
      deleteStatus: `Supprimer le statut`,
      confirmationModal: {
        title: `Supprimer le statut personnalisé`,
        text1: `Votre statut personnalisé, `,
        text2: `, sera supprimé définitivement. Êtes-vous sûr?`,
        confirmText: `Supprimer le statut`,
        cancelText: `Annuler`,
      },
      newStatus: `Nouveau statut`,
      toast: {
        deleteStatusSuccess: `Statut supprimé avec succès`,
      },
    },

    customStatusModal: {
      NameAddrHeader: `Ajouter un statut personnalisé`,
      editHeader: `Modifier le statut personnalisé`,
      inputLabel: `Nom du statut`,
      inputPlaceholder: `Nom`,
      type: `Type`,
      typePlaceholder: `Sélectionner le type`,
      away: `Absent`,
      online: `En ligne`,
      description: `Description`,
      descriptionPlaceholder: `À quoi sert ce statut?`,
      toast: {
        createSuccess: `Statut créé avec succès`,
        editSuccess: `Statut mis à jour avec succès`,
      },
      cancelButton: `Annuler`,
      saveButton: `Enregistrer`,
    },

    experimentsState: {
      queueDashboardEnabled: `Tableau de bord des files d'attente`,
      queueDashboardDescription: `Activer la fonctionnalité du tableau de bord des files d'attente.`,
      missedCallsEnabled: `Appels manqués`,
      missedCallsDescription: `Activer la fonctionnalité de suivi des appels manqués.`,
      badge: {
        beta: `Bêta`,
      },
      globalPhoneCapture: {
        title: `Capture Globale de Numéro de Téléphone`,
        description: {
          intro: `Vous permet de copier un numéro de téléphone depuis n'importe quelle application sur votre ordinateur, puis d'appuyer sur une touche de raccourci pour insérer ce numéro dans le clavier de numérotation de Mango Voice.`,
          howToUse: `Comment utiliser cette fonctionnalité : Choisissez d'abord la combinaison de touches de raccourci ci-dessous que vous souhaitez utiliser, puis appuyez sur le bouton "Définir la touche de raccourci".`,
          afterSet: `Une fois votre touche de raccourci définie, copiez simplement un numéro de téléphone comme vous le feriez normally dans n'importe quelle autre application (en utilisant Cmd/Ctrl+C, ou le menu contextuel), puis appuyez sur la touche de raccourci choisie pour charger ce numéro dans Mango Voice.`,
          note: `Remarque : Certaines touches de raccourci peuvent être utilisées par d'autres applications. Mango essaiera de détecter tout conflit et vous en informera.`,
        },
        activeSettingTitle: `Statut de la Touche de Raccourci :`,
        activeAndSet: `Touche de Raccourci Actuelle`,
        unsavedChanges: `Touche de Raccourci Proposée :`,
        configureTitle: `Configurer la Touche de Raccourci :`,
        keyLabel: `Touche :`,
        status: {
          enabled: `Activé`,
          disabled: `Désactivé`,
        },
        button: {
          setHotkey: `Définir la Touche de Raccourci`,
          disableFeature: `Désactiver la Touche de Raccourci`,
          enableFeature: `Activer la Touche de Raccourci`,
          clearHotkey: `Effacer la Touche de Raccourci`,
        },
        notSet: `Non défini`,
        toast: {
          hotkeyCleared: `Touche de raccourci effacée`,
        },
      },
    },

    shortcutKeysHelp: {
      title: `Raccourcis clavier du lecteur audio`,
      keyboardKeys: {
        spaceBar: "Barre d'espace",
        m: `M`,
        leftArrow: `←`,
        rightArrow: `→`,
        slash: `/`,
        shift: `Maj`,
      },
      playPause: `Lecture / Pause`,
      muteUnmute: `Muet / Activer le son`,
      rewind10s: `Reculer de 10 s`,
      advance10s: `Avancer de 10 s`,
      rewind3s: `Reculer de 3 s`,
      advance3s: `Avancer de 3 s`,
      scopeNote: `Les raccourcis de sourdine et de saut fonctionnent lorsque le focus du clavier est dans le lecteur audio.`,
    },

    newParkingLotModal: {
      header: `Ajouter une place de stationnement`,
      parkingSpot: `Place de stationnement`,
      label: `Étiquette`,
      cancelButton: `Annuler`,
      saveButton: `Enregistrer`,
      parking1Label: `Stationnement 1`,
      parking2Label: `Stationnement 2`,
      parking3Label: `Stationnement 3`,
      parking4Label: `Stationnement 4`,
      parking5Label: `Stationnement 5`,
      parking6Label: `Stationnement 6`,
      parking7Label: `Stationnement 7`,
      parking8Label: `Stationnement 8`,
      parking9Label: `Stationnement 9`,
      parking10Label: `Stationnement 10`,
    },

    newExtensionSubscriptionModal: {
      header: "Ajouter une présence d'extension",
      extension: `Extension`,
      cancelButton: `Annuler`,
      saveButton: `Enregistrer`,
    },

    dropdownSelect: {
      placeholder: `Sélectionner...`,
      noResultsFound: `Aucun résultat trouvé`,
      assignUserFirst: `Assignez d'abord un utilisateur`,
    },

    tooltips: {
      filter: `Filtrer`,
      dismiss: `Rejeter`,
      chartInformation: `Information du graphique`,
    },

    form: {
      placeholder: {
        searchNameOrNumber: `Rechercher un nom ou un numéro`,
        selectStatus: `Sélectionner le statut`,
        selectUser: `Sélectionner l'utilisateur`,
        selectVirtualFax: `Sélectionner le fax virtuel...`,
        searchNumbers: `Rechercher des numéros`,
        dateMonth: `MM`,
        dateDay: `JJ`,
        dateYear: `AAAA`,
        timeHours: `HH`,
        timeMinutes: `MM`,
        timeMeridiem: `AM`,
      },
    },

    newSpeedDialModal: {
      addSpeedDial: `Ajouter une numérotation abrégée`,
      editSpeedDial: `Modifier la numérotation abrégée`,
      contactName: `Nom du contact`,
      number: `Numéro`,
      cancelButton: `Annuler`,
      saveButton: `Enregistrer`,
    },

    actionsButton: {
      tooltipNewAction: `Nouvelle action`,
      newThread: `Nouveau fil de discussion`,
      newCall: `Nouvel appel`,
      newFax: `Nouvelle télécopie`,
    },

    accountButton: {
      settings: `Paramètres`,
      connectionStatus: `État de l'application`,
      switchPbx: `Changer de PBX`,
      openApp: "Ouvrir l'application",
      downloadApp: "Télécharger l'application",
      whatsNew: `Nouveautés`,
      giveFeedback: `Donner des commentaires`,
      helpCenter: "Centre d'aide",
      logOut: `Déconnexion`,
      apiDocs: `Documentation API`,
    },

    statusPanel: {
      title: `État de l'application`,
      tabBasic: `Base`,
      tabAdvanced: `Avancé`,
      tabListLabel: `Vues de l'état de l'application`,
      refresh: `Actualiser`,
      refreshing: `Actualisation…`,
      refreshed: `Mis à jour`,
      close: `Fermer`,
      copyDiagnostics: `Copier le diagnostic`,
      copied: `Copié`,
      overallHealthy: `Sain`,
      overallDegraded: `Dégradé`,
      overallDown: `Hors service`,
      overallIdle: `Inactif`,
      overallUnknown: `Inconnu`,
      summaryGood: `Tout semble fonctionner.`,
      summaryProblem: `Nous avons détecté un problème.`,
      fixNetworkOffline: `Vérifiez votre Wi-Fi ou votre câble réseau, puis réessayez.`,
      fixPhoneError: `Rechargez la page pour reconnecter le téléphone. Si le problème persiste, contactez le soutien.`,
      fixRealtimeReconnecting: `Reconnexion automatique en cours. Si cela persiste, rechargez la page.`,
      fixRealtimeSuspended: `L’application a été mise en pause. Elle devrait reprendre sous peu; rechargez si ce n’est pas le cas.`,
      fixRealtimeDisconnected: `Rechargez la page pour rétablir la messagerie et les mises à jour d’appels.`,
      rowInternet: `Internet`,
      rowPhoneService: `Service téléphonique`,
      rowMessaging: `Messagerie`,
      rowAppUpdates: `Mises à jour de l'application`,
      stateUpdateReady: `Mise à jour prête`,
      stateCantInstallUpdates: `Impossible d'installer les mises à jour`,
      stateUpdateBlocked: `Mise à jour bloquée`,
      stateUpdateReadyVersion: `Mise à jour prête ({{version}})`,
      stateUpdateDownloading: `Téléchargement de la mise à jour…`,
      stateUpdateDownloadingVersion: `Téléchargement de la mise à jour ({{version}})…`,
      stateUpdateCheckFailed: `Impossible de vérifier les mises à jour`,
      stateCheckingForUpdates: `Recherche de mises à jour…`,
      stateNotCheckedYet: `Pas encore vérifié`,
      checkAgain: `Vérifier à nouveau`,
      online: `En ligne`,
      offline: `Hors ligne`,
      on: `Activé`,
      off: `Désactivé`,
      stateOnline: `En ligne`,
      stateOffline: `Hors ligne`,
      stateConnected: `Connecté`,
      stateDisconnected: `Déconnecté`,
      stateRegisteredReady: `Enregistré et prêt`,
      stateConnecting: `Connexion…`,
      stateReconnecting: `Reconnexion`,
      stateSuspended: `Suspendu`,
      stateRegistrationError: `Erreur d'enregistrement`,
      regNotStarted: `Non démarré`,
      regRegistered: `Enregistré`,
      regUnregistered: `Non enregistré`,
      regTerminated: `Terminé`,
      transportNotStarted: `Non démarré`,
      transportConnected: `Connecté`,
      transportDisconnected: `Déconnecté`,
      sectionSip: `SIP`,
      sectionMessaging: `Messagerie / temps réel`,
      sectionNetwork: `Réseau`,
      sectionTelephony: `Téléphonie`,
      sectionEnvironment: `Environnement`,
      labelRegistration: `Enregistrement`,
      labelTransport: `Transport`,
      labelLastError: `Dernière erreur`,
      labelWebSocket: `WebSocket`,
      labelLastHeartbeat: `Dernier signal`,
      heartbeatAgo: `il y a {{seconds}} s`,
      heartbeatStale: `il y a {{seconds}} s (obsolète)`,
      heartbeatNone: `Aucun encore`,
      labelReconnectAttempts: `Tentatives de reconnexion`,
      labelBrowser: `Navigateur`,
      sectionAudio: `Audio`,
      labelMicPermission: `Autorisation du microphone`,
      labelMicInput: `Microphone (entrée)`,
      labelSpeaker: `Haut-parleur (sortie)`,
      deviceCount: `{{count}} trouvé(s)`,
      deviceDefault: `Par défaut du système`,
      deviceNone: `Aucun détecté`,
      sectionCall: `Appel en cours`,
      callNone: `Aucun appel en cours`,
      labelCallStatus: `État`,
      labelCallDirection: `Direction`,
      labelCallSource: `Source`,
      labelCallHold: `En attente`,
      labelCallMuted: `En sourdine`,
      labelCallDuration: `Durée`,
      labelLatestVersion: `Dernière version`,
      labelUpToDate: `À jour`,
      labelOutOfDate: `Mise à jour disponible`,
      labelChannel: `Canal`,
      labelPlatform: `Plateforme`,
      sectionSession: `Session`,
      labelSignedIn: `Connecté`,
      labelTokenExpiry: `La session expire`,
      tokenExpired: `Expirée`,
      tokenValid: `Valide`,
      tokenNone: `Aucune session active`,
      labelNotifications: `Notifications`,
      labelLocalStorage: `Stockage local`,
      storageWritable: `Accessible en écriture`,
      storageBlocked: `Bloqué`,
      navChipDegraded: `État de l'application : attention requise`,
      navChipDown: `État de l'application : problème détecté`,
      navChipAria: `Problème détecté. Ouvrir l'état de l'application.`,
      sectionEvents: `Événements de connexion récents`,
      noEvents: `Aucun changement de connexion durant cette session : la connexion est restée stable.`,
      eventOnline: `Réseau en ligne`,
      eventOffline: `Réseau hors ligne`,
      eventWsConnected: `Temps réel connecté`,
      eventWsReconnecting: `Temps réel en reconnexion`,
      eventWsSuspended: `Temps réel suspendu`,
      eventWsDisconnected: `Temps réel déconnecté`,
      labelPbx: `PBX`,
      labelPbxId: `ID du PBX`,
      labelPbxUuid: `UUID du PBX`,
      labelDoNotDisturb: `Ne pas déranger`,
      labelRespondBusy: `Répondre occupé au 2e appel`,
      labelAppVersion: `Version de l'application`,
      labelBuild: `Version de compilation`,
      labelCaptured: `Capturé`,
      labelUserAgent: `Agent utilisateur`,
      extensions: `Postes`,
      noExtensions: `Aucun poste attribué.`,
      thisSession: `Cette session`,
    },

    contactsPage: {
      emptyDetailMessage: `Aucun contact sélectionné`,
      toast: {
        copyNumberSuccess: `Numéro de téléphone copié dans le presse-papiers`,
        copyNumberError: `Impossible de copier le numéro de téléphone`,
      },
    },

    contactsListView: {
      searchPlaceholder: `Rechercher un nom ou un numéro`,
      searchLabel: `Rechercher des contacts`,
      contactSourceContent: `Tous les contacts`,
      emptyNotice: {
        noContactsYet: `Pas encore de contacts ici`,
        contactSupport: `Contactez notre équipe d'assistance pour connecter vos contacts patients. Les extensions internes apparaîtront également ici après les avoir configurées sur`,
        noContactsFound: `Aucun contact trouvé`,
        noMatchingContacts: `Nous n'avons trouvé aucun contact correspondant à`,
      },
    },

    contactItems: {
      primary: `Principal`,
      actionButton: {
        copyNumber: `Copier le numéro`,
        callNumber: `Appeler le numéro`,
        messageNumber: `Envoyer un message au numéro`,
        sendFax: `Envoyer une télécopie`,
        callNumberLabel: `Appeler le {{number}}`,
        messageNumberLabel: `Envoyer un message au {{number}}`,
        sendFaxLabel: `Envoyer une télécopie au {{number}}`,
        copyNumberLabel: `Copier le {{number}}`,
        unblockNumberLabel: `Débloquer le {{number}}`,
      },
      emptyContactItem:
        "Aucun numéro de téléphone enregistré pour ce contact pour l'instant",
      contactInformation: `Informations de contact`,
      contactSource: `Source du contact:`,
      fromPms: `De {{pmsName}}`,
    },

    contactEventHistory: {
      recentActivity: `Activité récente`,
      timespanText: `Derniers 14 jours`,
      historyLabel: {
        messaging: `Fil de discussion`,
        inboundCall: `Appel entrant`,
        outboundCall: `Appel sortant`,
        inboundFax: `Télécopie reçue`,
        outboundFax: `Télécopie envoyée`,
        voicemail: `Messagerie vocale`,
      },
    },

    quickDialView: {
      tab: {
        favorites: `Favoris`,
        recentlyDialed: `Appels récents`,
      },
      groupName: {
        parkingSpots: `Places de stationnement`,
        lineExtensions: `Extensions de ligne`,
        speedDial: `Numérotation abrégée`,
      },
      phoneSettings: `Paramètres du téléphone`,
    },

    quickDialListItem: {
      empty: {
        parkingSpots: `Pour afficher les places de stationnement ici, ajustez les paramètres de votre téléphone web`,
        lineExtensions:
          "Ajoutez n'importe quelle extension de ligne pour voir sa disponibilité ici",
        speedDial: `Enregistrez les numéros que vous appelez fréquemment avec la numérotation abrégée`,
        recentlyDialedPrimary: `Aucun numéro récemment composé`,
        recentlyDialedSecondary: `Après avoir passé des appels, vos numéros récemment composés apparaîtront ici.`,
      },
      button: {
        webPhoneSettings: `Paramètres du téléphone web`,
        configurePresence: `Configurer la présence`,
        configureSpeedDial: `Configurer la numérotation abrégée`,
      },
      parkingLot: {
        title: `Place de stationnement`,
        subtitle: `Place de stationnement`,
      },
      tooltip: {
        pickUpCall: "Prendre l'appel",
        startCall: "Démarrer l'appel",
        parkCall: "Parquer l'appel",
        newCall: `Démarrer un nouvel appel`,
        transferCall: "Transférer l'appel",
      },
    },

    callContactButton: {
      startCall: "Démarrer l'appel",
      startCallAriaLabel: `Démarrer l'appel : {{name}}, {{number}}`,
      startCallNumberAriaLabel: `Démarrer l'appel : {{number}}`,
      callNumber: `Appeler le {{number}}`,
      callNumberWithLabel: `Appeler le {{number}} - {{label}}`,
      otherNumbersAriaLabel: `Autres numéros de {{name}}`,
    },

    phoneNumberInput: {
      placeholder: `Entrez le numéro`,
      clearButton: `Effacer`,
      inputLabel: `Numéro de téléphone à composer`,
    },

    phoneNumberMultiDropdown: {
      allNumbers: `Tous les numéros`,
    },

    phoneSearchInput: {
      placeholder: `Entrez un nom ou un numéro`,
      clearButton: `Effacer`,
      inputLabel: `Rechercher par nom ou numéro`,
    },

    contactCardsList: {
      emptySearchText: `Entrez un nom ou un numéro ci-dessus pour lancer une recherche`,
    },

    outOfCallView: {
      tabButtonDialpad: `Clavier`,
      tabButtonSearch: `Recherche`,
    },

    contactCardList: {
      searchResults: `Résultats de la recherche`,
      noMatchingContacts: "Nous n'avons trouvé aucun contact correspondant à ",
    },

    callButton: {
      startCall: "Démarrer l'appel",
      endCall: "Mettre fin à l'appel",
      disabled: `Désactivé`,
      unknown: `Inconnu`,
    },

    callControlButton: {
      endCall: "Mettre fin à l'appel",
      splitConference: `Diviser la conférence`,
      mergeCalls: `Fusionner les appels`,
      newCall: `Nouvel appel`,
      transfer: `Transférer`,
      park: `Parquer`,
      mute: `Muet`,
      keypad: `Clavier`,
      hold: `Mettre en attente`,
      audioSettings: `Paramètres audio`,
    },

    onboardingView: {
      welcomeText: "Passez des appels depuis n'importe quel navigateur",
      bodyText:
        "Passez et recevez des appels, transférez ou mettez en attente facilement, gérez plusieurs appels, ajoutez des favoris et des numéros abrégés. Votre communication, à votre façon, de n'importe où.",
      buttonLabel: `Activer le téléphone`,
      confirmModal: {
        title: `Aucune extension de ligne disponible`,
        message1:
          "Vous n'avez aucune extension de ligne attribuée sur ce système téléphonique {{pbxName}}.",
        message2: `Pour utiliser la fonction téléphone, veuillez contacter votre administrateur système pour attribuer une extension de ligne.`,
        confirmText: `Ignorer`,
      },
    },

    numberComparisonDashboard: {
      invalidDateRange: 'Plage de dates invalide',
      dateRangeTooLarge: `La plage de dates est trop grande. Veuillez sélectionner une plage de 365 jours ou moins.`,
      dateRangeAdjustPrompt: `Veuillez ajuster votre plage de dates et réessayer.`,
      chartTitle: `Volume d'appels par numéro`,
      showingCount: `Affichage de {{displayed}} sur {{total}}`,
      counters: {
        totalCalls: {
          title: `Total des appels entrants`,
          subtitle: `Total des appels entrants sur tous les numéros`,
        },
        numberCount: {
          title: `Total des numéros`,
          subtitle: `Total des numéros de téléphone suivis`,
        },
        averageCalls: {
          title: `Moyenne par numéro`,
          subtitle: `Moyenne des appels entrants par numéro`,
        },
        topNumber: {
          title: `Meilleure performance`,
        },
      },
      dashboard: {
        errorText: 'Erreur lors du chargement des données de numéro',
        noDataText: 'Aucune donnée de numéro disponible',
      },
      showMore: `Afficher plus ({{remaining}} restants)`,
      unknown: `Inconnu`,
      notAvailable: `N/D`,
    },

    callControl: {
      audioSettings: {
        title: `Paramètres audio`,
        outputSource: `Source de sortie - Haut-parleurs`,
        inputSource: "Source d'entrée - Microphone",
      },
      parkCall: "Parquer l'appel",
      transferCall: "Transférer l'appel",
    },

    transferTarget: {
      buttonText: "Transférer l'appel",
      buttonAriaLabel: `Transférer l'appel : {{name}}, {{number}}`,
    },

    transferHeader: {
      placeholder: `Entrez le numéro`,
      ariaLabel: `Transférer`,
      inputLabel: `Transférer au numéro`,
    },

    parkTarget: {
      buttonText: "Parquer l'appel",
      buttonAriaLabel: `Parquer l'appel : {{name}}`,
    },

    controlDrawer: {
      ariaLabel: `Fermer le tiroir`,
    },

    dashboardsPage: {
      item: {
        agentStatus: "Statut de l'agent",
        eventLog: `Journal des événements`,
        inboundAnswerRate: `Taux de réponse entrant`,
        numberComparison: `Comparaison de Numéros`,
        extensionComparison: `Comparaison d'Extensions`,
        queueDashboard: `Tableau de bord de file d'attente`,
      },
      group: {
        callCenter: "Centre d'appels",
        callDashboards: `Tableaux de bord des appels`,
      },
    },

    queueDashboard: {
      emptyState: {
        title: `Aucune information trouvée`,
        description: `Sélectionnez une file d'attente dans la liste pour voir les données pertinentes`,
      },
      filters: {
        title: `File d'attente`,
        subtitle: `Voyez comment l'activité d'appels de votre équipe se compare`,
      },
      queueSelector: {
        placeholder: `Sélectionner dans la liste`,
        ariaLabel: `Sélectionner une file d'appels`,
      },
      metrics: {
        callersInQueue: `Appelants en file d'attente`,
        maxWait: `Temps d'attente maximum`,
        averageWait: `Temps d'attente moyen`,
        maxAbandoned: `Maximum abandonné`,
        averageAbandoned: `Moyenne abandonnée`,
        dropRate: `Taux d'abandon`,
        answerRate: `Taux de réponse`,
        sampleHistory: `Historique d'échantillon`,
        sampleHistoryAriaLabel: `Sélectionner la fenêtre de temps de l'historique d'échantillon`,
      },
      agentsPanel: {
        title: `File d'attente des agents`,
        activeAgents: `Agents actifs`,
        inactiveAgents: `Agents inactifs`,
        searchPlaceholder: `Entrez le nom ou l'extension`,
        exportCsv: `Exporter CSV`,
        exportToast: {
          title: `Exporter`,
          description: `La fonctionnalité d'exportation CSV sera bientôt disponible.`,
        },
        loginFailed: {
          title: `Échec de la connexion`,
          description: `Échec de la connexion de l'agent à la file d'attente. Veuillez réessayer.`,
        },
        logoutFailed: {
          title: `Échec de la déconnexion`,
          description: `Échec de la déconnexion de l'agent de la file d'attente. Veuillez réessayer.`,
        },
      },
      callersTable: {
        title: `File d'attente entrante`,
        callerNumber: `Numéro d'appelant`,
        callerName: `Nom de l'appelant`,
        callTime: `Temps d'appel / d'attente`,
        status: `Statut`,
        emptyState: {
          title: `Aucune information trouvée`,
          description: `Il n'y a actuellement aucune information à afficher pour la file d'attente actuelle`,
        },
      },
      activeAgentsTable: {
        callerNumber: `Numéro d'appelant`,
        agentName: `Nom de l'agent`,
        ext: `Ext`,
        loggedIn: `Connecté`,
        talkTime: `Temps de conversation`,
        answered: `Répondu`,
        missed: `Manqué`,
        total: `Total`,
        status: `Statut`,
        lastOffered: `Dernière offre`,
        action: `Action`,
        emptyState: {
          title: `Aucun agent trouvé`,
          description: `Il n'y a actuellement aucune information à afficher pour la file d'attente actuelle`,
        },
      },
      inactiveAgentsTable: {
        agent: `Agent`,
        ext: `Ext`,
        lastLoggedOut: `Dernière déconnexion`,
        status: `Statut`,
        action: `Action`,
        emptyState: {
          title: `Aucun agent trouvé`,
          description: `Il n'y a actuellement aucune information à afficher pour la file d'attente actuelle`,
        },
      },
      agentRow: {
        changeStatus: `Changer le statut`,
        offline: `Hors ligne`,
      },
      settings: {
        alertHoldTime: `Temps d'alerte en attente`,
        alertHoldTimeAriaLabel: `Sélectionner le seuil d'alerte d'attente`,
        refreshEvery: `Actualiser toutes les`,
        refreshAriaLabel: `Sélectionner l'intervalle d'actualisation`,
        seconds_one: `{{count}} seconde`,
        seconds_other: `{{count}} secondes`,
        minutes_one: `{{count}} min`,
        minutes_other: `{{count}} min`,
        hours_one: `{{count}} h`,
        hours_other: `{{count}} h`,
      },
      errorDisplay: {
        retrying_one: `Nouvelle tentative dans {{count}} seconde...`,
        retrying_other: `Nouvelle tentative dans {{count}} secondes...`,
        retryNow: `Réessayer maintenant`,
        retryingButton: `Nouvelle tentative...`,
        persistentMessage: `L'actualisation automatique a été mise en pause en raison d'échecs répétés.`,
      },
      status: {
        ready: `Prêt`,
        onCall: `En appel`,
        ringing: `Sonnerie`,
        available: `Disponible`,
        break: `Pause`,
        waiting: `En attente`,
        answered: `Répondu`,
        cancelled: `Annulé`,
      },
    },

    inboundAnswerRate: {
      header: `Taux de réponse entrant`,
      subtitle: `Affiche le pourcentage d'appels entrants répondus`,
      filters: {
        dateRange: `Période`,
        number: `Numéro`,
        maxPhoneNumbers: `(max {{max}})`,
      },
      counters: {
        answerRate: {
          title: `Taux de réponse`,
          subtitle: `Pourcentage d'appels répondus`,
        },
        totalCalls: {
          title: `Total des appels`,
          subtitle: `Total des appels entrants`,
        },
        answered: {
          title: `Appels répondus`,
          subtitle: `Total des appels répondus`,
        },
        missed: {
          title: `Appels manqués`,
          subtitle: `Total des appels manqués`,
        },
      },
      dashboard: {
        title: `Statistiques du taux de réponse`,
        errorText: "Erreur lors du chargement des données d'appel",
        noDataText: "Aucune donnée d'appel disponible",
        tableViewPlaceholder: `Vue tableau à venir`,
      },
      metrics: {
        answered: `Répondu`,
        missed: `Manqué`,
        answerRate: `Taux de réponse`,
      },
      rechartTitle: `Appels par {{groupByTitle}}`,
      viewToggle: {
        chart: `Graphique`,
        table: `Tableau`,
      },
      table: {
        columns: {
          number: `Numéro`,
          answerRate: `Taux de réponse entrant`,
          answered: `Appels répondus`,
          missed: `Appels manqués`,
          total: `Total des appels`,
        },
        errorLoading: `Erreur lors du chargement des statistiques des numéros de téléphone`,
        noData: `Aucune donnée de numéro de téléphone disponible`,
        unknown: `Inconnu`,
      },
      invalidDateRange: `Plage de dates invalide`,
      dateRangeTooLarge: `La plage de dates est trop grande. Veuillez sélectionner une plage de 365 jours ou moins.`,
      dateRangeAdjustPrompt: `Veuillez ajuster votre plage de dates et réessayer.`,
    },

    voicemailLineChart: {
      rechartTitle: `Messages vocaux par {{groupByTitle}}`,
    },

    agentStatusFilters: {
      header: "Statut de l'agent",
      availability: `Disponibilité`,
      status: `Statut`,
      items: {
        online: `En ligne`,
        away: `Absent`,
      },
    },

    agentStatusTable: {
      agent: `Agent`,
      extension: `Extension`,
      currentStatus: `Statut actuel`,
      timeInStatus: `Temps dans le statut`,
      startedAt: `Commencé le`,
      actions: `Actions`,
      status: {
        offline: `Hors ligne`,
        inQueue: "En file d'attente",
      },
    },

    agentStatusActions: {
      tooltip: {
        changeStatus: `Changer de statut`,
      },
    },

    eventLog: {
      title: `Journal des événements`,
      filters: {
        allAgents: `Tous les agents`,
        searchAgents: `Rechercher des agents`,
      },
    },

    eventLogTable: {
      when: `Quand`,
      who: `Qui`,
      status: `Statut`,
      inQueue: "En file d'attente",
      changedBy: `Modifié par`,
      yes: `Oui`,
      no: `Non`,
      system: `Système`,
      unknown: `Inconnu`,
      failedToLoad: `Échec du chargement d'autres événements.`,
      retry: `Réessayer`,
      noRecords: `Aucun enregistrement trouvé.`,
      noRecordsHint: `Essayez d'ajuster ou d'effacer vos filtres pour en voir plus.`,
    },

    callDetailsOverviewTab: {
      missed: `Manqué`,
      answered: `Répondu`,
      textButton: `Message vocal enregistré`,
    },

    callDetailData: {
      missed: `Manqué`,
      answered: `Répondu`,
      inProgress: `En cours`,
      failed: `Échec`,
      direction: {
        inbound: `Entrante`,
        outbound: `Sortante`,
        internal: `Interne`,
      },
    },

    callFilters: {
      buttonTitle: `Filtre`,
      sections: {
        direction: `Direction`,
        outcome: `Résultat`,
        sentiment: `Sentiment`,
        status: `Statut`,
        callTrait: `Caractéristique d'appel`,
        duration: `Durée`,
        user: `Utilisateur`,
        aiAgent: `Agent IA`,
      },
      direction: {
        inbound: `Entrant`,
        outbound: `Sortant`,
        internal: `Interne`,
      },
      outcome: {
        missed: `Manqué`,
        answered: `Répondu`,
      },
      sentiment: {
        office: `Bureau`,
        patient: `Patient`,
        negative: `Négatif`,
        neutral: `Neutre`,
        positive: `Positif`,
      },
      status: {
        inProgress: `En cours`,
        completed: `Terminé`,
        failed: `Échec`,
        canceled: `Annulé`,
        busy: `Occupé`,
      },
      callTrait: {
        voicemailRecorded: `Message vocal enregistré`,
        externallyTransferred: `Transféré externe`,
      },
      duration: {
        longerThan: `Plus long que`,
        shorterThan: `Plus court que`,
        tenSeconds: `10 secondes`,
        oneMinute: `1 minute`,
        fiveMinutes: `5 minutes`,
        tenMinutes: `10 minutes`,
      },
      user: {
        unknown: `Utilisateur inconnu`,
      },
      aiAgent: {
        unknown: `Agent IA inconnu`,
      },
    },

    rechartsBarChart: {
      tooltip: {
        modalView: `Vue modale`,
        answerRate: `Taux de réponse :`,
        total: `Total :`,
      },
      noChartData: `Aucune donnée de graphique disponible`,
      weekOf: `Semaine du {{date}}`,
    },

    dateDropdown: {
      today: "Aujourd'hui",
      yesterday: `Hier`,
      last7Days: `7 derniers jours`,
      last14Days: `14 derniers jours`,
      last30Days: `30 derniers jours`,
      thisWeek: `Cette semaine`,
      lastWeek: `La semaine dernière`,
      thisMonth: `Ce mois-ci`,
      lastMonth: `Le mois dernier`,
      last60Days: `60 derniers jours`,
      last90Days: `90 derniers jours`,
      customRange: `Plage personnalisée`,
    },

    dateTimeRange: {
      after: `Après : {{date}}`,
      before: `Avant : {{date}}`,
      selectDateRange: `Sélectionner la plage de dates`,
      buttonPlaceholder: `Sélectionner la plage de dates`,
    },

    dateTimeRangeModal: {
      after: `Après `,
      before: `Avant `,
      optional: `(facultatif)`,
      selectDateRange: `Sélectionner la plage de dates`,
      buttonPlaceholder: `Sélectionner la plage de dates`,
      clearButton: `Effacer`,
      setDateRangeButton: `Définir la plage de dates`,
      monthLabel: `{{label}} : mois`,
      dayLabel: `{{label}} : jour`,
      yearLabel: `{{label}} : année`,
      hourLabel: `{{label}} : heure`,
      minuteLabel: `{{label}} : minute`,
      meridiemLabel: `{{label}} : a.m./p.m.`,
    },

    queueControlButton: {
      inQueue: "En file d'attente",
      outOfQueue: "Hors file d'attente",
      doNotDisturb: `Ne pas déranger`,
      online: `En ligne`,
      offline: `Hors ligne`,
      joinQueue: "Entrer dans la file d'attente",
      leaveQueue: "Quitter la file d'attente",
      goOffline: `Hors ligne`,
    },

    queueStatusMenu: {
      online: `En ligne`,
      away: `Absent`,
      goOffline: `Hors ligne`,
      joinQueue: "Entrer dans la file d'attente",
    },

    changelogModal: {
      whatsNewLabel: `Nouveautés`,
      noResults: `Aucun journal des modifications disponible`,
      doneButton: `Terminé`,
      loadingData: `Chargement du journal des modifications...`,
      latest: `(Plus récent)`,
      releasedLabel: `Publié`,
    },

    queueToasts: {
      loggedInToQueue: `Connecté à la file d'attente`,
      loggedOutOfQueue: `Déconnecté de la file d'attente`,
      agentStatusUpdated: `Statut de l'agent mis à jour`,
      unableToUpdateStatus: `Impossible de mettre à jour le statut`,
      queueUpdateErrorMessage: `Veuillez vous assurer que cet Utilisateur/Extension est ajouté à une File d'Attente d'Appels dans le Portail Admin ou contactez le Support.`,
      genericUpdateErrorMessage: `Une erreur s'est produite lors de la mise à jour du statut. Veuillez réessayer ou contacter le Support.`,
      ok: `OK`,
    },

    regionSelector: {
      settingsTitle: `Région de Données Mango`,
      settingsDescription: `Ceci indique la région où vos données sont conservées dans l'écosystème Mango.`,
      selectRegion: `Sélectionner la région`,
      regionInfoTooltip: `Représente la région de données Mango, pas votre emplacement.`,
      regions: {
        unitedStates: `États-Unis`,
        unitedKingdom: `Royaume-Uni`,
      },
    },

    announcementBanner: {
      infoLabel: `Annonce d'information : {{title}}`,
      warningLabel: `Annonce d'avertissement : {{title}}`,
      criticalLabel: `Annonce critique : {{title}}`,
      dismiss: `Fermer l'annonce`,
      collapse: `Réduire l'annonce`,
      expand: `Développer l'annonce`,
    },
    bannerPager: {
      carousel: `Bannières`,
      slide: `Bannière {{current}} sur {{total}}`,
      position: `{{current}}/{{total}}`,
      previous: `Bannière précédente`,
      next: `Bannière suivante`,
      carouselRole: `carrousel`,
      slideRole: `diapositive`,
    },

    appVersionBanner: {
      desktopUpdateAvailable: `La version {{version}} de {{appName}} est disponible!`,
      webUpdateAvailable: `Une nouvelle version de l'application web Mango est disponible!`,
      restartAndUpdate: `Redémarrer et mettre à jour`,
      updateNow: `Mettre à jour maintenant`,
      whatsNew: `Nouveautés`,
      remindLater: `Me rappeler plus tard`,
      dismiss: `Ignorer`,
    },

    clockSkewBanner: {
      message: `L'horloge de votre appareil est décalée de plus de quelques minutes. Cela peut faire en sorte que les appels, la messagerie et d'autres fonctions se comportent de façon inattendue. Veuillez activer la synchronisation automatique de la date et de l'heure dans les paramètres de votre système.`,
    },

    updateBlockedBanner: {
      message: `L'application n'a pas pu terminer la mise à jour. Cela est généralement dû à un antivirus ou à un logiciel de sécurité qui bloque la mise à jour. Demandez à votre équipe TI d'autoriser la mise à jour de l'application, ou téléchargez la dernière version.`,
      downloadLatest: `Télécharger la dernière version`,
    },

    updatePermissionBanner: {
      message: `L'application ne peut pas installer de mises à jour sur cet ordinateur en raison de la façon dont elle a été installée. Suivez notre article d'aide ou transmettez-le à votre équipe TI.`,
      howToFix: `Comment corriger`,
      updateAnyway: `Mettre à jour quand même`,
    },

    updateCheck: {
      checkForUpdates: `Vérifier les mises à jour`,
      restartAndUpdate: `Redémarrer et mettre à jour`,
      checking: `Vérification des mises à jour...`,
      upToDate: `L'application est à jour`,
      checkFailed: `Échec de la vérification des mises à jour`,
      versionAvailable: `La version {{version}} est disponible`,
      downloading: `Téléchargement... {{percent}} %`,
      downloaded: `Version {{version}} téléchargée`,
      errorOccurred: `Une erreur est survenue lors de la vérification des mises à jour.`,
    },
    updateRequirement: {
      recommendedMessage: `Une nouvelle version de {{appName}} est disponible. Mettez à jour pour obtenir les derniers correctifs.`,
      recommendedMessageWithDate: `Mettez à jour {{appName}} d'ici le {{date}} pour continuer à l'utiliser.`,
      requiredDuringCall: `Cette version de {{appName}} n'est plus prise en charge. À la fin de votre appel, vous devrez faire la mise à jour pour continuer.`,
      update: `Mettre à jour`,
      later: `Plus tard`,
      downloading: `Téléchargement : {{percent}} %`,
      restartToUpdate: `Redémarrer pour mettre à jour`,
      downloadInstaller: `Télécharger le programme d'installation`,
      requiredTitle: `Mise à jour requise`,
      requiredMessage: `Cette version de {{appName}} ({{currentVersion}}) n'est plus prise en charge. Mettez à jour pour continuer à utiliser l'application.`,
      callsNotice: `Tant que vous n'avez pas fait la mise à jour, cette application ne peut pas recevoir d'appels. Les appels sont dirigés vers vos autres appareils, groupes de sonnerie ou votre messagerie vocale.`,
      preparing: `Préparation de la mise à jour...`,
      downloadingProgress: `Téléchargement de la mise à jour : {{percent}} %`,
      progressLabel: `Progression du téléchargement de la mise à jour`,
      manualInstallMessage: `L'application ne peut pas installer la mise à jour automatiquement. Téléchargez et installez la version la plus récente.`,
      useWebApp: `Utiliser l'application Web`,
      contactSupport: `Contacter le soutien`,
      alertTitle: `{{appName}} doit être mis à jour`,
      alertBody: `Les appels sont dirigés vers d'autres appareils ou vers la messagerie vocale jusqu'à la mise à jour.`,
      copyDownloadLink: `Copier le lien de téléchargement`,
      linkCopied: `Lien copié`,
    },

    callDetails: {
      title: `Détails de l'appel`,
      callTimeline: `Chronologie de l'appel`,
      callFlow: `Flux d'appel`,
      started: `Démarré`,
      ended: `Terminé`,
      answerTime: `Temps de réponse`,
      callDuration: `Durée de l'appel`,
      callOn: `Appel du`,
      statisticsNotAvailable: `Les statistiques ne sont pas disponibles`,
      transcriptNotAvailable: `La transcription n'est pas disponible`,
      noRecordingAvailable: `Aucun enregistrement disponible`,
      callSummary: `Résumé de l'appel`,
      callStatistics: `Statistiques de l'appel`,
      header: {
        copyLinkToCall: `Copier le lien vers l'appel`,
        copyLinkToCallAtTimestamp: `Copier le lien vers l'appel à l'horodatage`,
        downloadAudio: `Télécharger l'audio`,
        closePanel: `Fermer le panneau`,
        expand: `Développer`,
        moreActions: `Plus d'actions`,
      },
      sections: {
        sentimentByQuarter: {
          title: `Sentiment par quart`,
          tooltip: `Cela montre le sentiment du patient et du bureau, reflétant le ton émotionnel de la conversation. Chaque quart est classé comme positif (vert), neutre (gris) ou négatif (rouge).`,
          agentOverall: `Agent: {{score}} Global`,
          customerOverall: `Client: {{score}} Global`,
          patient: `Patient`,
          office: `Bureau`,
        },
        officeTalkTime: {
          title: `Temps de parole du bureau`,
          tooltip: `Ce graphique circulaire montre une répartition du temps que le bureau a passé à parler versus écouter pendant l'appel. Idéalement, les agents devraient passer plus de temps à écouter qu'à parler, visant une répartition de 50-60% de parole et 40-50% d'écoute pour une interaction efficace avec le client.`,
          talking: `Parler`,
          listening: `Écouter`,
        },
        officeTalkSpeed: {
          title: `Vitesse de parole du bureau`,
          tooltip: `Cela montre la vitesse globale de parole du bureau en mots par minute (mpm). Une plage normale est de 120-150 mpm, ce qui est clair et facile à comprendre. Les vitesses en dessous de 100 mpm peuvent sembler trop lentes, tandis que les vitesses au-dessus de 160 mpm peuvent être difficiles à suivre pour les patients.`,
          wordsPerMinute: `Mots Par Minute`,
        },
        interruptions: {
          title: `Interruptions`,
          tooltip: `Cela montre une répartition du nombre de fois où le patient et le bureau se sont interrompus mutuellement. C'est utile pour évaluer la fluidité de la conversation.`,
          total: `Total`,
          patient: `Patient`,
          office: `Bureau`,
        },
        holdAndPauseTime: {
          title: `Temps d'attente et pauses`,
          tooltip: `Cela montre combien de temps l'appelant a passé en attente ou en silence, et le pourcentage de l'appel total. Les temps d'attente plus longs que la normale sont mis en évidence en rouge.`,
          percentageOfCall: `{{percentage}}% de l'appel`,
        },
      },
      toast: {
        linkCopied: `Lien copié dans le presse-papiers`,
        linkCopyFailed: `Échec de la copie du lien dans le presse-papiers.`,
        voicemailTranscriptCopied: `Transcription du message vocal copiée dans le presse-papiers.`,
        voicemailTranscriptCopyFailed: `Impossible de copier la transcription du message vocal.`,
        noVoicemailTranscript: `Aucune transcription de message vocal à copier.`,
        voicemailTranscriptCopyError: `Impossible de copier la transcription du message vocal. Veuillez réessayer.`,
        summaryCopied: `Résumé copié dans le presse-papiers.`,
        summaryCopyFailed: `Impossible de copier le résumé. Veuillez réessayer.`,
        noSummary: `Aucun résumé à copier.`,
        feedbackThanks: `Merci pour vos commentaires!`,
        feedbackThumbsUpFailed: `Échec du signalement de l'action J'aime.`,
        feedbackThumbsDownFailed: `Échec du signalement de l'action Je n'aime pas.`,
      },
      voicemail: {
        title: `Messagerie vocale`,
        loading: `Chargement de la transcription du message vocal...`,
        accessDenied: `Ce message vocal a été laissé dans une boîte de réception à laquelle vous n'avez pas accès. Contactez votre administrateur système.`,
        deleted: `Le message vocal a été supprimé.`,
        notAvailable: `Message vocal non disponible.`,
        transcriptionNotAvailable: `Transcription du message vocal non disponible.`,
      },
      summary: {
        title: `Résumé`,
        processing: `Traitement de la transcription de l'appel...`,
        notFound: `Aucun résumé trouvé`,
        notAvailable: `Aucun résumé de transcription disponible.`,
      },
      margoSummary: {
        title: `Résumé de Margo`,
        copy: `Copier le résumé de Margo`,
        copied: `Résumé de Margo copié`,
        copySuccess: `Résumé de Margo copié dans le presse-papiers.`,
        copyFailure: `Impossible de copier le résumé de Margo. Veuillez réessayer.`,
      },
      tabs: {
        overview: `Aperçu`,
        transcripts: `Transcriptions`,
        stats: `Statistiques`,
      },
      sentiment: {
        title: `Sentiment`,
        patient: `Patient`,
        office: `Bureau`,
        positive: `Positif`,
        negative: `Négatif`,
        neutral: `Neutre`,
      },
      tooltip: {
        copyToClipboard: `Copier dans le presse-papiers`,
        goToVoicemail: `Aller au message vocal`,
        accurate: `Précis`,
        inaccurate: `Imprécis`,
        copyLinkToSearch: `Copier le lien vers la recherche`,
        fullscreen: `Plein écran`,
      },
    },

    calls: {
      searchLabel: `Rechercher des appels`,
      export: {
        button: `Exporter CSV`,
        starting: `Démarrage...`,
        preparing: `Préparation de l'exportation...`,
        processing: `Exportation...`,
        completed: `Exporté`,
        success: `Le téléchargement du CSV a commencé`,
        successTruncated: `Exportation terminée (résultats tronqués à 1M de lignes)`,
        error: `Échec de l'exportation`,
        errorTooMany: `Trop d'exportations en cours. Veuillez patienter et réessayer.`,
        errorInvalid: `Paramètres d'exportation non valides.`,
        errorNotFound: `Exportation introuvable. Le serveur a peut-être redémarré. Veuillez réessayer.`,
        errorGeneric: `Impossible de démarrer l'exportation.`,
        errorStatusCheck: `Impossible de vérifier le statut de l'exportation.`,
        toastProcessingTitle: `Exportation en cours`,
        toastProcessingDescription: `Votre CSV est en préparation. Le téléchargement démarrera automatiquement.`,
        unsupportedFiltersHeader: `L'exportation CSV ne prend pas en charge ces filtres :`,
        filterSearch: `Recherche`,
      },
      transcriptCell: {
        noTranscriptAvailable: `Aucune transcription disponible.`,
        inProgress: `La transcription est en cours de génération, veuillez revenir plus tard.`,
        audioTooLong: `Transcription indisponible: l'audio de l'appel était trop long.`,
        viewTranscript: `Voir la transcription`,
        noTranscript: `Aucune transcription disponible`,
        transcriptInProgress: `Transcription en cours`,
        transcriptUnavailable: `Transcription indisponible`,
        openVoicemail: `Ouvrir la messagerie vocale`,
      },
      detail: {
        notFound: `Oups, cet enregistrement a été supprimé ou n'existe pas. Si vous avez besoin d'aide, contactez le soutien.`,
        unknownNumber: `Numéro inconnu`,
        unknownSource: `Inconnu`,
      },
    },

    missedCalls: {
      emptyState: `Aucun appel manqué`,
      emptyStateSubtitle: `Tous les appels ont été répondu`,
      description: `Suivre et gérer les appels manqués`,
      instructions: `Utilisez les filtres et les plages de dates pour trouver des appels manqués spécifiques`,
      errorLoadingMissedCalls: `Erreur lors du chargement des appels manqués`,
      pleaseTryAgainLater: `Veuillez réessayer plus tard`,
      countLabel: `{{count}} Appels manqués`,
      refresh: `Actualiser`,
      followUpStatus: {
        open: `Ouvert`,
        returnedCallBack: `Retourné - Rappeler`,
        returnedSMS: `Retourné - SMS`,
        returnedVoicemail: `Retourné - Message vocal`,
        returnedEmail: `Retourné - Courriel`,
        returnedNoAnswer: `Retourné - Pas de réponse`,
        noFollowUpRequired: `Aucun suivi requis`,
        assignUserFirst: `Assigner un utilisateur d'abord`,
      },
      filters: {
        sections: {
          type: `Type`,
          status: `Statut`,
          user: `Utilisateur`,
          phoneNumber: `Numéro de téléphone`,
        },
        type: {
          voicemail: `Messagerie vocale`,
          abandoned: `Abandonnée`,
        },
        userFallback: `Utilisateur {{id}}`,
      },
      assignedUser: {
        loading: `Chargement...`,
        loadingShort: `Chargement`,
        unassigned: `Non assigné`,
        userFallback: `Utilisateur {{id}}`,
      },
      type: {
        voicemailAlt: `Messagerie vocale`,
        abandonedAlt: `Abandonnée`,
        abandonedTitle: `Abandonnée`,
        abandonedDescription: `L'appel n'a pas été répondu et le client n'a pas laissé de message vocal`,
      },
    },

    callsList: {
      noCallsFound: `Aucun appel trouvé`,
      tryDifferentFilters: `Essayez des filtres différents`,
    },

    callsTable: {
      label: `Appels`,
      openCallDetails: `Voir les détails de l'appel, {{time}} {{date}}`,
      columns: {
        dateTime: `Date et heure`,
        outcome: `Résultat`,
        to: `À`,
        from: `De`,
        toFrom: `À/De`,
        duration: `Durée`,
        transcript: `Transcription`,
      },
    },

    missedCallsTable: {
      columns: {
        dateTime: `Date et heure`,
        from: `De`,
        to: `À`,
        type: `Type`,
        followUpTime: `Temps de suivi`,
        followUpStatus: `Statut de suivi`,
        assignedTo: `Assigné à`,
        action: `Action`,
      },
    },

    contactInfoCard: {
      callTarget: {
        from: `De`,
        to: `À`,
      },
      tooltip: {
        call: `Appeler`,
        message: `Message`,
        sendFax: `Envoyer un fax`,
        blockNumber: `Bloquer le numéro`,
        unblockNumber: `Débloquer le numéro`,
      },
    },

    contactCell: {
      menu: {
        callNumber: `Appeler le numéro`,
        copyNumber: `Copier le numéro`,
        messageNumber: `Message numéro`,
        sendFax: `Envoyer un fax`,
        blockNumber: `Bloquer le numéro`,
        unblockNumber: `Débloquer le numéro`,
        moreOptions: `Plus d'options`,
        moreOptionsFor: `Plus d'options pour {{name}}, {{time}} {{date}}`,
      },
    },

    reportingFilters: {
      dateRange: `Plage de dates`,
      number: `Numéro`,
      maxPhoneNumbers: `(max {{max}})`,
    },

    numberComparisonFilters: {
      numberComparison: `Comparaison de numéros`,
      subtitle: `Comparer le volume d'appels entrants entre les numéros de téléphone`,
      dateRange: `Plage de dates`,
      number: `Numéro`,
      maxPhoneNumbers: `(max {{max}})`,
    },

    numberComparisonTable: {
      columns: {
        name: `Nom du numéro de téléphone`,
        number: `Numéro de téléphone`,
        inboundCalls: `Appels entrants`,
        avgDuration: `Durée moyenne`,
      },
    },

    numberComparisonChart: {
      inboundCalls: `Appels entrants`,
      avgDuration: `Durée moyenne`,
    },

    extensionComparison: {
      retired: `Retiré`,
    },

    extensionComparisonDashboard: {
      invalidDateRange: `Plage de dates invalide`,
      dateRangeTooLarge: `La plage de dates est trop grande. Veuillez sélectionner une plage de 365 jours ou moins.`,
      dateRangeAdjustPrompt: `Veuillez ajuster votre plage de dates et réessayer.`,
      chartTitle: `Volume d'appels par extension`,
      showingCount: `Affichage de {{displayed}} sur {{total}}`,
      notAvailable: `N/D`,
      counters: {
        totalCalls: {
          title: `Total des appels`,
          subtitle: `Total des appels sur toutes les extensions`,
        },
        averageCalls: {
          title: `Moyenne par extension`,
          subtitle: `Moyenne des appels par extension`,
        },
        averageMinutes: {
          title: `Minutes moyennes par extension`,
          subtitle: `Moyenne des minutes par extension`,
        },
        topExtension: {
          title: `Meilleure performance`,
        },
      },
      dashboard: {
        errorText: `Erreur lors du chargement des données d'extension`,
        noDataText: `Aucune donnée d'extension disponible`,
      },
    },

    extensionComparisonFilters: {
      title: `Comparaison des extensions`,
      subtitle: `Comparer le volume d'appels entre les extensions`,
      directionLabel: `Direction`,
      extensionsLabel: `Extensions`,
      direction: {
        all: `Entrant et sortant`,
        inbound: `Entrant`,
        outbound: `Sortant`,
      },
    },

    extensionComparisonChart: {
      extensionLabel: `Extension {{ext}}`,
      totalCalls: `Total des appels`,
      totalMinutes: `Total des minutes`,
      avgDuration: `Durée moyenne`,
      showMore: `Afficher plus ({{remaining}} restants)`,
      totalCallsTitle: `Total des appels`,
      totalMinutesTitle: `Total des minutes`,
    },

    extensionComparisonTable: {
      columns: {
        extension: `Extension`,
        calls: `Appels`,
        percentCalls: `% du total`,
        minutes: `Minutes`,
        percentMinutes: `% du total`,
      },
    },

    extensionMultiDropdown: {
      allExtensions: `Toutes les extensions`,
    },

    extensionPills: {
      extensionsSelected: `{{count}} extensions sélectionnées`,
    },

    dashboards: {
      noDataAvailable: `Aucune donnée disponible`,
      gettingPbx: `Récupération du PBX...`,
      noStatisticsAvailable: `Aucune statistique disponible`,
      noGridData: `Aucune donnée de grille`,
      errorLoadingStatistics: `Erreur lors du chargement des statistiques`,
      errorLoadingCallData: `Erreur lors du chargement des données d'appel`,
      noCallDataAvailable: `Aucune donnée d'appel disponible`,
      errorLoadingVoicemailData: `Erreur lors du chargement des données de messagerie vocale`,
      noVoicemailDataAvailable: `Aucune donnée de messagerie vocale disponible`,
      csvExport: {
        buttonLabel: `Exporter CSV`,
        exported: `Exporté`,
        success: `CSV exporté`,
        failed: `Échec de l'exportation CSV`,
        headers: {
          inboundAnswerRate: {
            startDateTime: `Date/Heure de Début`,
            endDateTime: `Date/Heure de Fin`,
            answeredCalls: `Appels Répondus`,
            missedCalls: `Appels Manqués`,
            totalCalls: `Total des Appels`,
            answerRatePercent: `Taux de Réponse %`,
          },
          numberComparison: {
            phoneNumber: `Numéro de Téléphone`,
            displayNumber: `Numéro d'Affichage`,
            name: `Nom`,
            inboundCalls: `Appels Entrants`,
            totalDurationSeconds: `Durée Totale (secondes)`,
            averageDurationSeconds: `Durée Moyenne (secondes)`,
          },
          extensionComparison: {
            extension: `Extension`,
            totalCalls: `Total des appels`,
            totalMinutes: `Total des minutes`,
            totalDurationSeconds: `Durée totale (secondes)`,
            averageDurationSeconds: `Durée moyenne (secondes)`,
          },
        },
      },
      unknown: `Inconnu`,
      notAvailable: `N/D`,
    },

    aria: {
      backspace: `Retour arrière`,
      toggleColorMode: `Changer le mode de couleur`,
    },

    callAnalytics: {
      empty: {
        noTranscriptRecord: `Oups — il ne semble pas y avoir de transcription pour cet appel.`,
        noCallSelected: `Aucun appel sélectionné`,
      },
      stats: {
        agentTalkTime: `Temps de parole de l'agent`,
        talking: `En train de parler: {{duration}} ({{percent}}%)`,
        listening: `À l'écoute: {{duration}} ({{percent}}%)`,
        agentTalkSpeed: `Vitesse de parole de l'agent`,
        wordsPerMinute: `{{count}} mots par minute (moyenne)`,
        holdTimeAndPauses: `Temps d'attente et pauses`,
        holdPercentOfCall: `{{duration}} ({{percent}}% de l'appel)`,
        interruptionsTotal: `Interruptions: {{count}} au total`,
        interruptionsAgent: `Agent: {{count}} ({{percent}}%)`,
        interruptionsCustomer: `Client: {{count}} ({{percent}}%)`,
      },
      transcript: {
        office: `Bureau`,
        patient: `Patient`,
        silence: `Silence {{duration}}`,
      },
    },

    filterModal: {
      header: `Filtres`,
      apply: `Appliquer les filtres`,
      clear: `Effacer`,
      clearSection: `Effacer {{title}}`,
      buttonTitle: `Filtres`,
      tooltipOneApplied: `{{title}} ({{count}} filtre appliqué)`,
      tooltipManyApplied: `{{title}} ({{count}} filtres appliqués)`,
    },

    previewModal: {
      rotate: `Pivoter`,
      imagePreview: `Aperçu de l'image`,
    },

    pdfViewer: {
      loadError: `Impossible de charger ce fichier`,
    },

    mangoPlusAds: {
      stayRelevant: `Restez pertinent`,
      inTodaysWorld: `dans le monde d'aujourd'hui`,
      bodyHeading: `Qui n'aime pas texter?`,
      paragraph1: `Aujourd'hui, les gens préfèrent texter plutôt que d'appeler. Choisissez de texter vos clients — gagnez du temps et de l'énergie!`,
      paragraph2: `Les textos ne sont qu'un des nombreux avantages de Mango Plus. Parlez à notre équipe des ventes d'un essai d'un mois avant d'acheter.`,
      learnMore: `En savoir plus`,
    },

    outboundPhoneSearch: {
      placeholder: `Sélectionner un numéro`,
    },

    faxFilters: {
      directionTooltip: `Filtre de direction`,
      allFaxes: `Toutes les télécopies`,
    },

    messagingThread: {
      dropFileToSend: `Déposez le fichier pour l'envoyer`,
    },

    resetPassword: {
      togglePasswordVisibility: `Afficher ou masquer le mot de passe`,
    },

    resourceErrorBoundary: {
      defaultMessage: `Une erreur inattendue s'est produite.`,
      notFoundFallback: `Oups, cet enregistrement a été supprimé ou n'existe pas. Si vous avez besoin d'aide, contactez le soutien.`,
      takeMeBack: `Retour`,
    },

    moveFaxModal: {
      toast: {
        errorMoving: `Une erreur s'est produite lors du déplacement de la télécopie.`,
        notMarkedUnread: `La télécopie n'a pas été marquée comme non lue.`,
        moveFailed: `Impossible de déplacer la télécopie vers le télécopieur virtuel sélectionné.`,
        errorTitle: `Erreur lors du déplacement de la télécopie`,
      },
      noAccessWarning: `Si vous n'avez pas accès au télécopieur virtuel sélectionné, vous ne pourrez plus voir cette télécopie une fois qu'elle aura été déplacée.`,
    },

    filePrinter: {
      printFailed: `Échec de l'impression du fichier.`,
    },

    router: {
      loadingContent: `Chargement du contenu...`,
    },

    resourceFailedToLoad: {
      permission: `Vous n'avez pas l'autorisation d'accéder à cette boîte vocale`,
      deleted: `Messagerie vocale supprimée`,
      unavailable: `Messagerie vocale indisponible`,
      contactAdmin: `Pour obtenir l'accès, contactez votre administrateur système`,
    },

    tagInput: {
      commaSeparated: `Les valeurs multiples doivent être séparées par des virgules`,
      removeTag: `Retirer {{value}}`,
      valueNotAdded: `Cette valeur n'a pas pu être ajoutée`,
      valuesNotAdded: `Ces valeurs n'ont pas pu être ajoutées`,
      invalidValue: `Cette valeur n'est pas un {{valueType}} valide`,
      invalidValues: `Ces valeurs ne sont pas valides ({{valueType}})`,
      limitReached: `Maximum de {{maxTags}} atteint. Retirez-en un pour en ajouter un autre.`,
      errorAndLimit: `{{error}}. {{limit}}`,
    },

    unsavedChangesDialog: {
      title: `Modifications non enregistrées`,
      body: `Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page? Vos modifications seront perdues.`,
      stay: `Rester sur la page`,
      discard: `Annuler les modifications`,
    },

    blockedNumber: {
      blockNumbers: `Bloquer les numéros`,
    },

    notificationsBanner: {
      grantedPrefix: `Parfait, les préférences de notification peuvent être ajustées dans`,
      settings: `les paramètres`,
      prompt: `Mango fonctionne mieux avec les notifications pour vous tenir à jour.`,
      enable: `Activer les notifications!`,
    },

    switchboardEdit: {
      invalidDialPlan: `Plan de numérotation d'extension invalide`,
      invalidPbxId: `ID de PBX invalide`,
      loading: `Chargement du standard...`,
    },

    webPhoneExtras: {
      activeCall: `Appel actif`,
      failedSearch: `Recherche échouée`,
      otherLabel: `autre`,
      awayWithLabel: `Absent - {{label}}`,
    },

    callDetailsExtras: {
      callInProgress: `Appel en cours`,
      mayTakeMinutes: `Cela peut prendre plusieurs minutes`,
    },

    contactCombinedCell: {
      fromPrefix: `De:`,
      toPrefix: `À:`,
    },

    messaging:
      messagingFrCa as unknown as (typeof en)['translation']['messaging'],
    phoneNumbers:
      phoneNumbersFrCa as unknown as (typeof en)['translation']['phoneNumbers'],
    pbxLocations:
      pbxLocationsFrCa as unknown as (typeof en)['translation']['pbxLocations'],
    musicOnHold:
      musicOnHoldFrCa as unknown as (typeof en)['translation']['musicOnHold'],
    hotels: hotelsFrCa as unknown as (typeof en)['translation']['hotels'],
    soundClips:
      soundClipsFrCa as unknown as (typeof en)['translation']['soundClips'],
    ...systemSettingsFrCa,
    pbxSettings:
      pbxSettingsFrCa as unknown as (typeof en)['translation']['pbxSettings'],
    devices: devicesFrCa as unknown as (typeof en)['translation']['devices'],
    extensions:
      extensionsFrCa as unknown as (typeof en)['translation']['extensions'],
    userGroups:
      userGroupsFrCa as unknown as (typeof en)['translation']['userGroups'],
    webhooks: webhooksFrCa as unknown as (typeof en)['translation']['webhooks'],
  },
  support_phone_label: "Ligne d'assistance : {{phoneNumber, phone}}",
  user_profile_phone: `Votre numéro de téléphone enregistré est : {{userPhone, phone}}`,
} satisfies typeof en
